<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="true">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">商品企画メンテナンス</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body" [style.background-color]="this.kymw0900Model.backgroundColor">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="split_two_part">

          <div class="block-column" [style.width.px]="937">
            <div class="element-column">
              <div class="column-list">
                <label class="list-input-title" style="width: 182px;">Ｐコード</label>
                <div class="list-input-content">
                  <select id="cmb_PCode" #cmb_PCode class="combo-box-required pcode" tabindex="0"
                    [(ngModel)]="this.kymw0900Model.selectedPCode" (change)="eventPCode_CHANGEHandler(null)"
                    forcedEnabledMode="true" style="width: 230px;">
                    <ng-template ngFor let-item [ngForOf]="this.kymw0900Model.pCodeList">
                      <option value="{{item.PCode}}">{{item.Caption}}</option>
                    </ng-template>
                  </select>
                  <app-clipboard-copy-icon [tabindex]="0" [forcedEnabledMode]="'true'" [tooltip]="'Ｐコードをコピー'"
                    value="{{this.kymw0900Model.pCode}}"></app-clipboard-copy-icon>
                </div>
              </div>
              <div class="block-row">
                <div class="column-list" style="width: 446px;">
                  <label class="list-input-title" style="width: 182px;">バイヤーコード</label>
                  <div class="list-input-content">
                    <input #txti_BuyerCode type="text" id="txti_BuyerCode"
                      plessInputTextSub [restrict]="'[ -￮]'" readonly
                      [(ngModel)]="this.kymw0900Model.buyerCode"/>
                  </div>
                  <label class="list-input-title">包材一括表示</label>
                  <div class="list-input-content">
                    <label><input #chk_PackMaterialShowFlag type="checkbox" id="chk_PackMaterialShowFlag" [tabindex]="-1"
                      [(ngModel)]="this.kymw0900Model.packMaterialShowFlag" />確認済</label>
                  </div>
                  <label class="list-input-title">部門コード</label>
                  <div class="list-input-content">
                    <app-class-code-combo-box #cmb_ClassCode id="cmb_ClassCode" [subid]="'cmb_ClassCode'"
                      class="combo-box-required" [forcedEnabledMode]="'none'" [tabindex]="0"
                      [blank]="true" [required]="true" [initFocusItem]="cmb_PCode"
                      (change)="eventClassCode_CHANGEHandler()">
                    </app-class-code-combo-box>
                  </div>                  
                </div>
                <div class="column-list" style="width: 432px;">
                  <label class="list-input-title" style="width: 182px;">大分類</label>
                  <div class="list-input-content">
                    <app-large-class-code-combo-box #cmb_LargeClassCode
                      class="combo-box-required" id="cmb_LargeClassCode"
                      [subid]="'cmb_LargeClassCode'" [tabindex]="0" [required]="true" [initFocusItem]="cmb_PCode"
                      [blank]="true" [classCodeComboBoxFlg]="true" [classCode]="cmb_ClassCode.selectedClassCode">
                    </app-large-class-code-combo-box>
                  </div>
                  <label class="list-input-title">中分類</label>
                  <div class="list-input-content">
                    <app-middle-class-code-combo-box #cmb_MiddleClassCode
                      class="combo-box-required" id="cmb_MiddleClassCode"
                      [subid]="'cmb_MiddleClassCode'" [tabindex]="0" [initFocusItem]="cmb_PCode"
                      [classCodeComboBoxFlg]="true" [largeClassCodeComboBoxFlg]="true" [blank]="true"
                      [classCode]="cmb_ClassCode.selectedClassCode"
                      [largeClassCode]="cmb_LargeClassCode.selectedLargeClassCode" [required]="true">
                    </app-middle-class-code-combo-box>
                  </div>
                  <label class="list-input-title">小分類</label>
                  <div class="list-input-content">
                    <app-small-class-code-combo-box #cmb_SmallClassCodeList
                      class="combo-box-required" id="cmb_SmallClassCodeList"
                      [subid]="'cmb_SmallClassCodeList'" [tabindex]="0" [initFocusItem]="cmb_PCode" [blank]="true"
                      [classCodeComboBoxFlg]="true" [largeClassCodeComboBoxFlg]="true"
                      [classCode]="cmb_ClassCode.selectedClassCode"
                      [largeClassCode]="cmb_LargeClassCode.selectedLargeClassCode"
                      [middleClassCode]="cmb_MiddleClassCode.selectedMiddleClassCode" [required]="true"
                      (change)="eventSmallClassCode_CHANGEHandler(null)">
                    </app-small-class-code-combo-box>
                  </div>
                </div>
              </div>
              <div class="column-list">
                <div class="list-input-title layout_balance" style="width: 182px;">
                  <label type="text" [style.white-space]="'nowrap'">商品案内用商品名</label>
                  <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                    <fa-icon [icon]="iconQuestion"></fa-icon></label>
                </div>
                <div class="list-input-content">
                  <app-not-null-text-input #txti_GuideGoodsName id="txti_GuideGoodsName"
                    [subid]="'txti_GuideGoodsName'" [required]="true" [maxChars]="30" [restrict]="'[ -￮]'"
                    [tabindex]="0" [fullOnly]="true" [(ngModel)]="this.kymw0900Model.guideGoodsName"
                    [forcedEnabledMode]="'none'" (blur)="eventGuideGoodsName_FOCUS_OUTHandler()"
                    [useDisabledBgColor]="true" class="guide-goods-name">
                  </app-not-null-text-input>
                </div>
                <div class="list-input-title layout_balance">
                  <label type="text" [style.white-space]="'nowrap'">商品案内用規格名</label>
                  <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                    <fa-icon [icon]="iconQuestion"></fa-icon></label>
                </div>
                <div class="list-input-content">
                  <app-not-null-text-input #txti_GuideStandardName id="txti_GuideStandardName"
                    [subid]="'txti_GuideStandardName'" [required]="true" [maxChars]="15" [restrict]="'[ -￮]'"
                    [tabindex]="0" [fullOnly]="true" [useDisabledBgColor]="true"
                    [(ngModel)]="this.kymw0900Model.guideStandardName"
                    (blur)="eventGuideStandardName_FOCUS_OUTHandler(null)" class="guide-standard-name">
                  </app-not-null-text-input>
                </div>
              </div>
            </div>
            <!-- タブ領域 -->
            <wj-tab-panel #tab_pCode id="tab_pCode" [style.background-color]="this.kymw0900Model.backgroundColor"
              (selectedTabChange)="selectedTabPCodeChange()">
              <wj-tab>
                <a id="a_BaseInfo" #a_BaseInfo (keydown)="nextFocusForReadonlyUser($event)">基本</a>
                <div class="block-column">
                  <div class="element-column">
                    <div class="block-row">
                      <div class="column-list">
                        <div class="list-input-title layout_balance">
                          <label type="text" [style.white-space]="'nowrap'">お届け明細書用商品名(漢字)</label>
                          <label aria-label="EC" data-microtip-position="bottom" role="tooltip" class="question">
                            <fa-icon [icon]="iconQuestion"></fa-icon></label>
                        </div>
                        <div class="list-input-content">
                          <app-not-null-text-input #txti_DeliveryGoodsNameKanji [required]="true"
                            id="txti_DeliveryGoodsNameKanji" [subid]="'txti_DeliveryGoodsNameKanji'"
                            [restrict]="'[ -￮]'" [maxChars]="15" [forcedEnabledMode]="'none'"
                            [useDisabledBgColor]="true" [tabindex]="0"
                            [(ngModel)]="this.kymw0900Model.deliveryGoodsNameKanji" [fullOnly]="true">
                          </app-not-null-text-input>
                        </div>
                        <label class="list-input-title">発注用商品名(カナ)</label>
                        <div class="list-input-content">
                          <app-not-null-text-input #txti_DeliveryGoodsNameKana [required]="true"
                            id="txti_DeliveryGoodsNameKana" [subid]="'txti_DeliveryGoodsNameKana'" [maxChars]="15"
                            [restrict]="'[ -￮]'" [forcedEnabledMode]="'none'" [toUpperCase]="true"
                            [useDisabledBgColor]="true" [tabindex]="0"
                            [(ngModel)]="this.kymw0900Model.deliveryGoodsNameKana" [halfOnly]="true"
                            class="disabled-color-disabled" (input)="eventDeliveryGoodsNameKana_deleteCommaHandler()"
                            (compositionstart)="onCompStart()" (compositionend)="onCompDeleteCommaEnd($event)">
                          </app-not-null-text-input>
                        </div>
                        <label class="list-input-title">OCR商品名</label>
                        <div class="list-input-content">
                          <app-not-null-text-input #txti_OcrGoodsName id="txti_OcrGoodsName"
                            [subid]="'txti_OcrGoodsName'" [width]="'17rem'" [required]="true" [maxChars]="16"
                            [restrict]="'[ -￮]'" [forcedEnabledMode]="'none'" [useDisabledBgColor]="true" [tabindex]="0"
                            [fullOnly]="true" [(ngModel)]="this.kymw0900Model.ocrGoodsName"
                            class="disabled-color-disabled">
                          </app-not-null-text-input>
                        </div>
                        <label class="list-input-title">消費税区分</label>
                        <div class="list-input-content">
                          <app-code-combo-box #cmb_ConsumeTaxDivList [required]="true" [codeDiv]="'ct016'"
                            [labelField]="'codeValueName'" id="cmb_ConsumeTaxDivList" [subid]="'cmb_ConsumeTaxDivList'"
                            class="combo-box-required" [forcedEnabledMode]="'none'"
                            [tabindex]="-1" [(ngModel)]="this.kymw0900Model.consumeTaxDiv" (change)="consumeTaxDiv_CHANGEHandler()">
                          </app-code-combo-box>
                        </div>
                        <label class="list-input-title">サイクル期間</label>
                        <div class="list-input-content">
                          <app-code-combo-box #cmb_CycleTerm [codeDiv]="'ct290'" [labelField]="'codeValueName'"
                            id="cmb_CycleTerm" [subid]="'cmb_CycleTerm'" [forcedEnabledMode]="'none'" [tabindex]="-1">
                          </app-code-combo-box>
                        </div>
                        <label class="list-input-title">商品案内温度帯区分</label>
                        <div class="list-input-content">
                          <app-code-combo-box #cmb_RoomTempZoneDiv [codeDiv]="'ct061'" [labelField]="'codeValueName'"
                            id="cmb_RoomTempZoneDiv" [subid]="'cmb_RoomTempZoneDiv'" [forcedEnabledMode]="'none'"
                            [tabindex]="0">
                          </app-code-combo-box>
                        </div>
                      </div>
                      <div class="column-list">
                        <label class="list-input-title">お届け明細書用規格名(漢字)</label>
                        <div class="list-input-content">
                          <app-not-null-text-input #txti_DeliveryStandardNameKanji [required]="true" [width]="'11rem'"
                            id="txti_DeliveryStandardNameKanji" [subid]="'txti_DeliveryStandardNameKanji'"
                            [maxChars]="10" [restrict]="'[ -￮]'" [forcedEnabledMode]="'none'"
                            [useDisabledBgColor]="true" [fullOnly]="true" [tabindex]="0"
                            [(ngModel)]="this.kymw0900Model.deliveryStandardNameKanji" class="disabled-color-disabled">
                          </app-not-null-text-input>
                        </div>
                        <label class="list-input-title">発注用規格名(カナ)</label>
                        <div class="list-input-content">
                          <app-not-null-text-input #txti_DeliveryStandardNameKana [required]="true" [width]="'11rem'"
                            id="txti_DeliveryStandardNameKana" [subid]="'txti_DeliveryStandardNameKana'" [maxChars]="10"
                            [restrict]="'[ -￮]'" [forcedEnabledMode]="'none'" [useDisabledBgColor]="true"
                            [halfOnly]="true" [tabindex]="0" [toUpperCase]="true"
                            [(ngModel)]="this.kymw0900Model.deliveryStandardNameKana" class="disabled-color-disabled"
                            (input)="eventDeliveryStandardNameKana_deleteCommaHandler()"
                            (compositionstart)="onCompStart()" (compositionend)="onCompDeleteCommaEnd($event)">
                          </app-not-null-text-input>
                        </div>
                        <label style="visibility: collapse;">dummy</label>
                        <label style="visibility: collapse;">dummy</label>
                        <label class="list-input-title">消費税率</label>
                        <div class="list-input-content">
                          <input type="text" #txti_ConsumeTaxDivRate id="txti_ConsumeTaxDivRate"
                            class="text-label-required" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="2"
                            backgroundColor="#93EAFC" forcedEnabledMode="none"
                            [(ngModel)]="this.kymw0900Model.consumeTaxDivRate"
                            (blur)="eventConsumeTaxDivRate_FOCUS_OUTHandler()" tabindex="-1" [style.width.rem]="4" />
                        </div>
                        <label class="list-input-title">EDLP商品区分</label>
                        <div class="list-input-content">
                          <app-code-combo-box #cmb_EdlpDiv [codeDiv]="'ct374'" [labelField]="'codeValueName'"
                            id="cmb_EdlpDiv" [subid]="'cmb_EdlpDiv'" [forcedEnabledMode]="'none'" [tabindex]="0"
                            [blank]="false"></app-code-combo-box>
                        </div>
                      </div>
                    </div>
                    <div class="block-row">
                      <div class="column-list">
                        <div class="list-input-title layout_balance" style="width: 7rem">
                          <label type="text" [style.white-space]="'nowrap'">賞味期間</label>
                          <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                            <fa-icon [icon]="iconQuestion"></fa-icon></label>
                        </div>
                        <div class="list-input-content">
                          <input #txti_ConsumeTerm type="text" id="txti_ConsumeTerm" plessInputTextSub
                            [restrict]="'[0-9]'" [maxlength]="4" forcedEnabledMode="none" [tabindex]="0"
                            [(ngModel)]="this.kymw0900Model.consumeTerm" [style.width.rem]="7"/>
                        </div>
                        <div class="list-input-title layout_balance">
                          <label type="text" [style.white-space]="'nowrap'">消費期限</label>
                          <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question"
                            withTooltip>
                            <fa-icon [icon]="iconQuestion"></fa-icon></label>
                        </div>
                        <div class="list-input-content">
                          <input #txti_ConsumeByDate type="text" id="txti_ConsumeByDate" plessInputTextSub
                            [restrict]="'[0-9]'" [maxlength]="4" forcedEnabledMode="none" [tabindex]="0"
                            [(ngModel)]="this.kymw0900Model.consumeByDate" [style.width.rem]="7" />
                        </div>
                        <label class="list-input-title">残賞味期間</label>
                        <div class="list-input-content">
                          <input #txti_LeaveConsumeTerm type="text" id="txti_LeaveConsumeTerm" plessInputTextSub
                            [restrict]="'[0-9]'" [maxlength]="4" forcedEnabledMode="none" [tabindex]="0"
                            [(ngModel)]="this.kymw0900Model.leaveConsumeTerm" [style.width.rem]="7"/>
                        </div>
                      </div>
                      <div class="column-list">
                        <label class="list-input-title">eフレンズ送信</label>
                        <div class="list-input-content">
                          <label><input #chk_EFriendsSendDiv type="checkbox"
                            id="chk_EFriendsSendDiv" forcedEnabledMode="none" [tabindex]="0"
                              [(ngModel)]="this.kymw0900Model.eFriendsSendDiv" disabled="true" />送信不要</label>
                        </div>
                        <label class="list-input-title">目隠し区分</label>
                        <div class="list-input-content">
                          <app-code-combo-box #cmb_BlindDiv [codeDiv]="'ct353'" [labelField]="'codeValueName'"
                            id="cmb_BlindDiv" [subid]="'cmb_BlindDiv'" [forcedEnabledMode]="'none'" [tabindex]="0">
                          </app-code-combo-box>
                        </div>
                        <label class="list-input-title">コマ配置予定区分</label>
                        <div class="list-input-content">
                          <app-code-combo-box #cmb_KomaScheduleDiv [codeDiv]="'ctp147'" [labelField]="'codeValueName'"
                            id="cmb_KomaScheduleDiv" [subid]="'cmb_KomaScheduleDiv'" [forcedEnabledMode]="'none'"
                            [tabindex]="0" [blank]="true" [style.width.rem]="7"></app-code-combo-box>
                        </div>
                      </div>
                      <div class="column-list">
                        <label class="list-input-title">ユニットプライス区分</label>
                        <div class="list-input-content">
                          <app-code-combo-box #cmb_UnitPriceDiv id="cmb_UnitPriceDiv" [subid]="'cmb_UnitPriceDiv'"
                            [codeDiv]="'ct287'" [labelField]="'codeValueName'" [forcedEnabledMode]="'none'"
                            [tabindex]="0" [blank]="false"
                            [(ngModel)]="this.kymw0900Model.unitPriceDiv"></app-code-combo-box>
                        </div>
                        <label class="list-input-title">ユニットプライス単位</label>
                        <div class="list-input-content">
                          <app-text-input #txti_UnitPriceUnit id="txti_UnitPriceUnit" [subid]="'txti_UnitPriceUnit'"
                            type="text" [maxChars]="15" [displayCountField]="false" [forcedEnabledMode]="'none'"
                            [restrict]="'[ -￮]'" [tabindex]="0" [fullOnly]="true"
                            [(ngModel)]="this.kymw0900Model.unitPriceUnit" [style.width.rem]="18">
                          </app-text-input>
                        </div>
                        <div class="list-input-title layout_balance">
                          <label type="text" [style.white-space]="'nowrap'">ユニットプライス係数</label>
                          <label aria-label='誌面＋EC：ユニットプライス区分="1"のときユニットプライスが連携される' data-microtip-position="top"
                            role="tooltip" class="question">
                            <fa-icon [icon]="iconQuestion"></fa-icon></label>
                        </div>
                        <div class="list-input-content">
                          <input #txti_UnitPriceCoefficient type="text" id="txti_UnitPriceCoefficient" plessInputTextSub
                            [restrict]="'[0-9.]'" [maxlength]="7" forcedEnabledMode="none" [tabindex]="0"
                            [(ngModel)]="this.kymw0900Model.unitPriceCoefficient" [style.width.rem]="7" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <h3>関連Ｐコード</h3>
                    <div class="element-row">
                      <div class="column-list">
                        <label class="list-input-title">関連Ｐコード(旧)</label>
                        <div class="list-input-content">
                          <input #txti_RelationPcodeOld type="text" readonly id="txti_RelationPcodeOld"
                            forcedEnabledMode="none" plessInputTextSub
                            [restrict]="'[ -￮]'" [(ngModel)]="this.kymw0900Model.relationPcodeOld" class="pcode" />
                        </div>
                      </div>
                      <button id="btn_RelationPcode" class="btn-secondary" #btn_RelationPcode forcedEnabledMode="none"
                        [tabindex]="0" (click)="eventConfig_CLICKHandler(null)">設定</button>
                      <div class="column-list">
                        <label class="list-input-title">関連Ｐコード(新)</label>
                        <div class="list-input-content">
                          <input #txti_RelationPcodeNew type="text" readonly id="txti_RelationPcodeNew"
                            forcedEnabledMode="none"
                            plessInputTextSub [restrict]="'[ -￮]'"
                            [(ngModel)]="this.kymw0900Model.relationPcodeNew" class="pcode" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <h3>酒税法関連</h3>
                    <div class="block-row">
                      <div class="column-list" style="width: 500px;">
                        <label class="list-input-title" style="width: 140px;">酒類コード</label>
                        <div class="list-input-content">
                          <app-code-combo-box #cmb_LiquorCode [codeDiv]="'ct362'" [labelField]="'codeValueName'"
                            id="cmb_LiquorCode" [subid]="'cmb_LiquorCode'" [forcedEnabledMode]="'none'" [tabindex]="0">
                          </app-code-combo-box>
                        </div>
                        <label class="list-input-title">容器形態</label>
                        <div class="list-input-content">
                          <app-code-combo-box #cmb_ContainerForm [codeDiv]="'ct360'" [labelField]="'codeValueName'"
                            id="cmb_ContainerForm" [subid]="'cmb_ContainerForm'" [forcedEnabledMode]="'none'"
                            [tabindex]="0">
                          </app-code-combo-box>
                        </div>
                      </div>
                      <div class="column-list">
                        <label class="list-input-title" style="width: 140px;">アルコール分別</label>
                        <div class="list-input-content">
                          <input #txti_AlcoholType type="text" id="txti_AlcoholType" plessInputTextSub
                            [restrict]="'[0-9.]'" [maxlength]="8" forcedEnabledMode="none" [tabindex]="0"
                            [(ngModel)]="this.kymw0900Model.alcoholType" [style.width.rem]="7" />
                        </div>
                        <label class="list-input-title">容器容量</label>
                        <div class="list-input-content">
                          <input type="text" #txti_ContainerCapacity id="txti_ContainerCapacity" plessInputTextSub
                            [restrict]="'[0-9]'" [maxlength]="5" forcedEnabledMode="none" [tabindex]="0"
                            [(ngModel)]="this.kymw0900Model.containerCapacity" (keydown)="nextFocus($event)" [style.width.rem]="7" />
                          <label>ml</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </wj-tab>
              <wj-tab forcedEnabledMode="true" id="cnv_CoopInfoTab" focusRect="false" [tabindex]="0">
                <a id="a_CoopInfo" #a_CoopInfo>会員</a>
                <div class="block-column">
                  <div>
                    <div>
                      <h2>マーク一覧</h2>
                      <div class="layout_end">
                        <app-checkbox-label #chk_AllcoopValue [label]="'すべての生協に同一の設定'" id="chk_AllcoopValue"
                          [subid]="'chk_AllcoopValue'" [tabindex]="0" [(ngModel)]="this.kymw0900Model.allcoopValue">
                        </app-checkbox-label>
                      </div>
                    </div>
                    <!-- マーク一覧 -->
                    <wj-flex-grid #dtg_CoopMarkList [style.width.%]="100" [style.height.px]="255" id="dtg_CoopMarkList"
                      [tabindex]="0" [itemsSource]="this.kymw0900Model.coopMarkList" [headersVisibility]="'Column'"
                      [allowSorting]="false" sortableColumns="false" [allowDragging]="'None'" editable="true"
                      [selectionMode]="'Row'" [isReadOnly]="true" [allowResizing]="'Columns'">
                      <wj-flex-grid-column [minWidth]="5" [width]="92" [binding]="'CoopName'" [header]="'会員生協'">
                      </wj-flex-grid-column>
                      <wj-flex-grid-column [minWidth]="5" [width]="201" [binding]="'Mark1Value'"
                        [header]="kymw0900Model.mark1Header" [isReadOnly]="true">
                        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                          <input type="checkbox" [tabindex]="-1" [(ngModel)]="cell.item.Mark1Value"
                            (change)="checkBoxEventCoopMark($event,dtg_CoopMarkList);eventEditHandler();
                            coopInfoUpdateIconCheck($event, cell, kymw0900Model.pricePatternLinkMarkList[0].PricePatternLinkMarkCode);"
                            [disabled]="!cell.item.DealCoopDiv || cell.item.Enabled !='1' || this.kymw0900Model.isDisabledForGrid ? true : false"
                            id="cb_coop_mark_1_{{cell.row.index}}" (mouseup)="$event.stopPropagation()" />
                        </ng-template>
                      </wj-flex-grid-column>
                      <wj-flex-grid-column [minWidth]="5" [width]="201" [binding]="'Mark3Value'"
                        [header]="kymw0900Model.mark3Header" [isReadOnly]="true">
                        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                          <input type="checkbox" [(ngModel)]="cell.item.Mark3Value" [tabindex]="-1"
                            (change)="checkBoxEventCoopMark($event,dtg_CoopMarkList);eventEditHandler();
                            coopInfoUpdateIconCheck($event, cell, kymw0900Model.pricePatternLinkMarkList[2].PricePatternLinkMarkCode);"
                            [disabled]="!cell.item.DealCoopDiv || cell.item.Enabled !='1' || this.kymw0900Model.isDisabledForGrid ? true : false"
                            id="cb_coop_mark_3_{{cell.row.index}}" (mouseup)="$event.stopPropagation()" />
                        </ng-template>
                      </wj-flex-grid-column>
                      <wj-flex-grid-column [minWidth]="5" [width]="201" [binding]="'Mark4Value'"
                        [header]="kymw0900Model.mark4Header" [isReadOnly]="true">
                        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                          <input type="checkbox" [(ngModel)]="cell.item.Mark4Value" [tabindex]="-1"
                            (change)="checkBoxEventCoopMark($event,dtg_CoopMarkList);eventEditHandler();
                            coopInfoUpdateIconCheck($event, cell, kymw0900Model.pricePatternLinkMarkList[3].PricePatternLinkMarkCode);"
                            [disabled]="!cell.item.DealCoopDiv || cell.item.Enabled !='1' || this.kymw0900Model.isDisabledForGrid ? true : false"
                            id="cb_coop_mark_4_{{cell.row.index}}" (mouseup)="$event.stopPropagation()" />
                        </ng-template>
                      </wj-flex-grid-column>
                      <wj-flex-grid-column [minWidth]="5" [width]="201" [binding]="'Mark5Value'"
                        [header]="kymw0900Model.mark5Header" [isReadOnly]="true">
                        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                          <input type="checkbox" [(ngModel)]="cell.item.Mark5Value" [tabindex]="-1"
                            (change)="checkBoxEventCoopMark($event,dtg_CoopMarkList);eventEditHandler();
                            coopInfoUpdateIconCheck($event, cell, kymw0900Model.pricePatternLinkMarkList[4].PricePatternLinkMarkCode);"
                            [disabled]="!cell.item.DealCoopDiv || cell.item.Enabled !='1' || this.kymw0900Model.isDisabledForGrid ? true : false"
                            id="cb_coop_mark_5_{{cell.row.index}}" (mouseup)="$event.stopPropagation()" />
                        </ng-template>
                      </wj-flex-grid-column>
                    </wj-flex-grid>
                  </div>
                  <div>
                    <h2>価格一覧</h2>
                    <div class="element-column">
                      <div class="block-row">
                        <div class="column-list">
                          <label class="list-input-title">供給(今回)</label>
                          <div class="list-input-content">
                            <input type="text" #txti_AllthistimeSupplyPrice id="txti_AllthistimeSupplyPrice"
                              plessInputTextSub [restrict]="'[0-9]'" [tabindex]="0" [maxlength]="7"
                               [(ngModel)]="this.kymw0900Model.allthistimeSupplyPrice" [style.width.rem]="7" />
                          </div>
                        </div>
                        <div class="column-list">
                          <label class="list-input-title">仕入(今回)</label>
                          <div class="list-input-content">
                            <input type="text" #txti_AllthistimeCostPrice id="txti_AllthistimeCostPrice" plessInputTextSub
                              [restrict]="'[.0-9]'" [tabindex]="0" [maxlength]="10"
                              [(ngModel)]="this.kymw0900Model.allthistimeCostPrice" [style.width.rem]="10" />
                          </div>
                        </div>
                        <div class="column-list">
                          <label class="list-input-title">価格パターン</label>
                          <div class="list-input-content">
                            <select #cmb_PricePattern id="cmb_PricePattern" tabindex="0"
                              [(ngModel)]="this.kymw0900Model.pricePatternLinkMarkCode">
                              <ng-template ngFor let-item [ngForOf]="this.kymw0900Model.pricePatternList">
                                <option value="{{item.CodeValue}}">{{item.CodeValueName}}</option>
                              </ng-template>
                            </select>
                          </div>
                        </div>
                      </div>
                      <button id="btn_BatchReflection" #btn_BatchReflection class="btn-secondary" [tabindex]="0"
                        style="min-width: 162px;" (click)="eventBatchReflection_CLICKHandler(null)">一括反映</button>
                      <!-- 価格一覧 -->
                      <wj-flex-grid #dtg_PriceList id="dtg_PriceList" [tabindex]="0" [style.height.px]="306"
                        [style.width.%]="100" [itemsSource]="this.kymw0900Model.coopPriceList"
                        [allowMerging]="'ColumnHeaders'" [headersVisibility]="'Column'" [allowDragging]="'None'"
                        [allowSorting]="false" [selectionMode]="'Row'" [isReadOnly]="true" [allowResizing]="'Columns'"
                        (keydown)="nextFocusForReadonlyUser($event)">
                        <wj-flex-grid-column [minWidth]="5" [width]="44" [binding]="'CoopShortName'" [header]="'生協'">
                        </wj-flex-grid-column>
                        <wj-flex-grid-column [minWidth]="5" [width]="50" [binding]="'SelectValue'" [header]="'選択'"
                          [align]="'center'" [isReadOnly]="true">
                          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                            <input type="checkbox" [tabindex]="-1" [(ngModel)]="cell.item.SelectValue"
                              [disabled]="!cell.item.EnabledCheck || !cell.item.DealCoopDiv || this.kymw0900Model.isDisabledForGrid || (cell.item.PromotionDiv === 'B' || cell.item.PromotionDiv === 'P')"
                              (change)="priceListCheckEvent($event,dtg_PriceList);eventEditHandler();"
                              forcedEnabledMode="true" [tabindex]="-1" id="cb_price_{{cell.row.index}}"
                              (mouseup)="$event.stopPropagation()" />
                          </ng-template>
                        </wj-flex-grid-column>
                        <wj-flex-grid-column [minWidth]="5" [width]="117" [binding]="'SelectItemCode'"
                          [header]="'アイテムコード'" [align]="'left'">
                          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                            <select #cmb_SelectItemCode id="cmb_SelectItemCode" [style.width.%]="'100'" [tabindex]="-1"
                              [(ngModel)]="cell.item.SelectItemCode"
                              [disabled]="!cell.item.DealCoopDiv || this.kymw0900Model.isDisabledForGrid || (cell.item.PromotionDiv === 'B' || cell.item.PromotionDiv === 'P')"
                              (change)="updateCoopRelateData($event,dtg_PriceList);eventEditHandler();setCoopListItemCodeEmptyFlg(cell);"
                              forcedEnabledMode="true" [tabindex]="-1">
                              <option value=""></option>
                              <ng-template ngFor let-item [ngForOf]="cell.item.Caption">
                                <option value="{{item.Caption}}">{{item.Caption}}</option>
                              </ng-template>
                            </select>
                          </ng-template>
                        </wj-flex-grid-column>
                        <wj-flex-grid-column [minWidth]="5" [width]="112" [binding]="'SelectPricePattern'"
                          [header]="'価格パターン'" [align]="'left'">
                          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                            <select #cmb_SelectPricePattern id="cmb_SelectPricePattern" [style.width.%]="'100'"
                              [tabindex]="-1" [(ngModel)]="cell.item.SelectPricePattern"
                              (change)="eventCoopPriceListRefreshHandler($any($event))"
                              [disabled]="!cell.item.DealCoopDiv || this.kymw0900Model.isDisabledForGrid || (cell.item.PromotionDiv === 'B' || cell.item.PromotionDiv === 'P') "
                              [tabindex]="-1">
                              <ng-template ngFor let-item [ngForOf]="this.kymw0900Model.pricePatternList">
                                <option value="{{item.CodeValue}}">{{item.CodeValueName}}</option>
                              </ng-template>
                            </select>
                          </ng-template>
                        </wj-flex-grid-column>
                        <wj-flex-grid-column [minWidth]="5" [width]="112" [binding]="'LSupplyPricecoefficient'"
                          [multiLine]="true" [header]="'供給価格\n(通常)'" [align]="'right'">
                          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                            <div [align]="'right'">{{cell.item.LSupplyPricecoefficient}}</div>
                          </ng-template>
                        </wj-flex-grid-column>
                        <wj-flex-grid-column [minWidth]="5" [width]="112" [binding]="'ThistimeSupplyPrice'"
                          [multiLine]="true" [header]="'今回供給\n価格'" [align]="'right'">
                          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                            <div [wjTooltip]="cell.item.SupplyPriceToolTipText">
                              <input type="text" [(ngModel)]="cell.item.ThistimeSupplyPrice" style="text-align:right"
                                [style.width.%]="100" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="7"
                                [tabindex]="0" autocomplete="off"
                                [disabled]="!cell.item.DealCoopDiv || this.kymw0900Model.isDisabledForGrid || (cell.item.PromotionDiv === 'B' || cell.item.PromotionDiv === 'P') || cell.item.Enabled !='1'"
                                (input)="eventEditHandler();" (blur)="changeThistimeSupplyPrice($event, dtg_PriceList)"
                                (keydown)="eventGridKeyDownHandler($event,dtg_PriceList,5)"
                                (focus)="this.dtg_PriceList.select(cell.row.index, 5);"
                                (change)="setPromotionThistimeSupplyPrice(dtg_PriceList, cell.item)" />
                            </div>
                          </ng-template>
                        </wj-flex-grid-column>
                        <wj-flex-grid-column [minWidth]="5" [width]="112" [binding]="'LCostPriceCoefficient'"
                          [multiLine]="true" [header]="'単品仕入\n価格(通常)'" [align]="'right'">
                          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                            <div [align]="'right'">{{cell.item.LCostPriceCoefficient}}</div>
                          </ng-template>
                        </wj-flex-grid-column>
                        <wj-flex-grid-column [minWidth]="5" [width]="112" [binding]="'ThistimeCostPrice'"
                          [multiLine]="true" [header]="'今回仕入\n価格'" [align]="'right'">
                          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                            <div [wjTooltip]="cell.item.CostPriceToolTipText">
                              <input type="text" [(ngModel)]="cell.item.ThistimeCostPrice" style="text-align:right"
                                [style.width.%]="100" plessInputTextSub [maxlength]="10" [restrict]="'[.0-9]'"
                                autocomplete="off"
                                [disabled]="!cell.item.DealCoopDiv || this.kymw0900Model.isDisabledForGrid"
                                (input)="eventEditHandler();" (blur)="changeThistimeCostPrice($event, dtg_PriceList)"
                                (keydown)="eventGridKeyDownHandler($event,dtg_PriceList,7);eventGridTabKeyHandler($event, dtg_PriceList, 7, 2);"
                                [tabindex]="0" />
                            </div>
                          </ng-template>
                        </wj-flex-grid-column>
                        <wj-flex-grid-column [minWidth]="5" [width]="124" [binding]="'CostPrice'" [header]="'仕入価格'"
                          [align]="'right'">
                          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                            <div [style.width.%]="100" class="align-right">
                              <span>{{ cell.item.CostPrice | number:'1.2-2' }}</span>
                            </div>
                          </ng-template>
                        </wj-flex-grid-column>
                      </wj-flex-grid>
                    </div>                    
                  </div>
                </div>
              </wj-tab>
              <wj-tab orcedEnabledMode="true" id="cnv_DetailsInfoTab" [tabIndex]="0">
                <a id="a_DetailsInfo" #a_DetailsInfo>詳細</a>
                <div class="block-column">
                  <div>
                    <h2>情報一覧</h2>
                    <!-- 情報一覧 -->
                    <div class="element-column">
                      <wj-flex-grid #dtg_CoopDetailList [style.width.%]="100" [style.height.px]="286"
                        id="dtg_CoopDetailList" [tabindex]="0" [itemsSource]="this.kymw0900Model.coopDetailList"
                        [allowMerging]="'ColumnHeaders'" [selectionMode]="'Row'" [headersVisibility]="'Column'"
                        [frozenColumns]="1" [allowSorting]="false" sortableColumns="false" verticalScrollPolicy="off"
                        lockedColumnCount="1" horizontalScrollPolicy="auto" rowHeight="25" [allowDragging]="'None'"
                        editable="true" [isReadOnly]="true" [allowResizing]="'Columns'">
                        <wj-flex-grid-column [minWidth]="5" [width]="75" [binding]="'CoopName'" [header]="'会員生協'">
                        </wj-flex-grid-column>
                        <wj-flex-grid-column [minWidth]="5" [width]="145" [binding]="'BrandType'" [header]="'ブランド区分'"
                          [align]="'left'">
                          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                            <select #cmb_BrandType id="cmb_BrandType" [style.width.%]="'100'" [tabindex]="-1"
                              [(ngModel)]="cell.item.BrandType" [disabled]="isDisabledCoopItem(cell, cmb_BrandType)"
                              (change)="eventEditHandler()">
                              <ng-template ngFor let-item [ngForOf]="this.kymw0900Model.brandTypeList">
                                <option value="{{item.CodeValue}}">{{item.CodeValueName}}</option>
                              </ng-template>
                            </select>
                          </ng-template>
                        </wj-flex-grid-column>
                        <wj-flex-grid-column [minWidth]="5" [width]="87" [binding]="'SetDiv'" [header]="'セット区分'"
                          [align]="'left'">
                          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                            <select #cmb_SetDiv id="cmb_SetDiv" [(ngModel)]="cell.item.SetDiv" [style.width.%]="'100'"
                              [tabindex]="-1" [disabled]="isDisabledCoopItem(cell, cmb_SetDiv)"
                              (change)="eventEditHandler()">
                              <ng-template ngFor let-item [ngForOf]="this.kymw0900Model.setDivList">
                                <option value="{{item.CodeValue}}">{{item.CodeValueName}}</option>
                              </ng-template>
                            </select>
                          </ng-template>
                        </wj-flex-grid-column>
                        <wj-flex-grid-column [minWidth]="5" [width]="90" [binding]="'AssortTempDiv'" [header]="'仕分温度帯'"
                          [align]="'left'">
                          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                            <select #cmb_AssortTempDiv id="cmb_AssortTempDiv" [style.width.%]="'100'" [tabindex]="-1"
                              [(ngModel)]="cell.item.AssortTempDiv"
                              [disabled]="isDisabledCoopItem(cell, cmb_AssortTempDiv)" (change)="eventEditHandler()">
                              <ng-template ngFor let-item [ngForOf]="this.kymw0900Model.assortTempDivList">
                                <option value="{{item.CodeValue}}">{{item.CodeValueName}}</option>
                              </ng-template>
                            </select>
                          </ng-template>
                        </wj-flex-grid-column>
                        <wj-flex-grid-column [minWidth]="5" [width]="210" [binding]="'OrderNumQuotaCode'"
                          [header]="'注文コード割当'" [align]="'left'">
                          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                            <select #cmb_OrderNumQuotaCode id="cmb_OrderNumQuotaCode" [style.width.%]="'100'"
                              [tabindex]="-1" [(ngModel)]="cell.item.OrderNumQuotaCode"
                              [disabled]="isDisabledCoopItem(cell, cmb_OrderNumQuotaCode) || !getEnabledCoop(cell.item.CoopCode)" 
                              (change)="eventOrderNumQuotaHandler($event);eventEditHandler()">
                              <ng-template ngFor let-item [ngForOf]="this.kymw0900Model.orderNumQuotaList_Ibaraki"
                                *ngIf="cell.item.CoopCode==142">
                                <option value="{{item.OrderNumQuotaCode}}">{{item.OrderNumQuotaCodeName}}
                                </option>
                              </ng-template>
                              <ng-template ngFor let-item [ngForOf]="this.kymw0900Model.orderNumQuotaList_Tochigi"
                                *ngIf="cell.item.CoopCode==163">
                                <option value="{{item.OrderNumQuotaCode}}">{{item.OrderNumQuotaCodeName}}
                                </option>
                              </ng-template>
                              <ng-template ngFor let-item [ngForOf]="this.kymw0900Model.orderNumQuotaList_Gunma"
                                *ngIf="cell.item.CoopCode==185">
                                <option value="{{item.OrderNumQuotaCode}}">{{item.OrderNumQuotaCodeName}}
                                </option>
                              </ng-template>
                              <ng-template ngFor let-item [ngForOf]="this.kymw0900Model.orderNumQuotaList_Chiba"
                                *ngIf="cell.item.CoopCode==240">
                                <option value="{{item.OrderNumQuotaCode}}">{{item.OrderNumQuotaCodeName}}
                                </option>
                              </ng-template>
                              <ng-template ngFor let-item [ngForOf]="this.kymw0900Model.orderNumQuotaList_Saitama"
                                *ngIf="cell.item.CoopCode==210">
                                <option value={{item.OrderNumQuotaCode}}>{{item.OrderNumQuotaCodeName}}
                                </option>
                              </ng-template>
                              <ng-template ngFor let-item [ngForOf]="this.kymw0900Model.orderNumQuotaList_Tokyo"
                                *ngIf="cell.item.CoopCode==302">
                                <option value={{item.OrderNumQuotaCode}}>{{item.OrderNumQuotaCodeName}}
                                </option>
                              </ng-template>
                              <ng-template ngFor let-item [ngForOf]="this.kymw0900Model.orderNumQuotaList_Nagano"
                                *ngIf="cell.item.CoopCode==515">
                                <option value={{item.OrderNumQuotaCode}}>{{item.OrderNumQuotaCodeName}}
                                </option>
                              </ng-template>
                              <ng-template ngFor let-item [ngForOf]="this.kymw0900Model.orderNumQuotaList_Niigata"
                                *ngIf="cell.item.CoopCode==451">
                                <option value={{item.OrderNumQuotaCode}}>{{item.OrderNumQuotaCodeName}}
                                </option>
                              </ng-template>
                            </select>
                          </ng-template>
                        </wj-flex-grid-column>
                        <wj-flex-grid-column [minWidth]="5" [width]="145" [binding]="'ProducingAreaComment1'"
                          [header]="'産地コメント１'">
                          <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                            <div class="layout_balance">
                              <label type="text" [style.white-space]="'nowrap'">産地コメント１</label>
                              <label aria-label="誌面＋EC" data-microtip-position="left" role="tooltip" class="question">
                                <fa-icon [icon]="iconQuestion"></fa-icon></label>
                            </div>
                          </ng-template>
                          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                            <input type="text" [(ngModel)]="cell.item.ProducingAreaComment1" [style.width.%]="'100'"
                              maxlength="50" plessInputTextSub [fullOnly]="true"
                              [disabled]="!this.kymw0900Model.coopPriceList[cell.row.index].DealCoopDiv || cell.item.Enabled !='1' || this.kymw0900Model.isDisabledForGrid || this.kymw0900Model.producingAreaCommentLock ? true : false"
                              (change)="eventEditHandler();" [tabindex]="0" autocomplete="off"
                              (keydown)="eventGridKeyDownHandler($event, dtg_CoopDetailList, 5)"
                              (focus)="this.dtg_CoopDetailList.select(cell.row.index, 5);" [restrict]="'[ -￮]'" />
                          </ng-template>
                        </wj-flex-grid-column>
                        <wj-flex-grid-column [minWidth]="5" [width]="145" [binding]="'ProducingAreaComment2'"
                          [header]="'産地コメント２'">
                          <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                            <div class="layout_balance">
                              <label type="text" [style.white-space]="'nowrap'">産地コメント２</label>
                              <label aria-label="誌面＋EC" data-microtip-position="left" role="tooltip" class="question">
                                <fa-icon [icon]="iconQuestion"></fa-icon></label>
                            </div>
                          </ng-template>
                          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                            <input type="text" [(ngModel)]="cell.item.ProducingAreaComment2" [style.width.%]="'100'"
                              maxlength="50" plessInputTextSub [fullOnly]="true"
                              [disabled]="!this.kymw0900Model.coopPriceList[cell.row.index].DealCoopDiv || cell.item.Enabled !='1' || this.kymw0900Model.isDisabledForGrid || this.kymw0900Model.producingAreaCommentLock ? true : false"
                              (change)="eventEditHandler()" [tabindex]="0" autocomplete="off"
                              (keydown)="eventGridKeyDownHandler($event, dtg_CoopDetailList, 6)"
                              (focus)="this.dtg_CoopDetailList.select(cell.row.index, 6);" [restrict]="'[ -￮]'" />
                          </ng-template>
                        </wj-flex-grid-column>
                      </wj-flex-grid>
                      <div class="column-list">
                        <div class="list-input-title">
                          <label>表組用商品名</label>
                          <label aria-label="誌面" data-microtip-position="top" role="tooltip" class="question">
                            <fa-icon [icon]="iconQuestion"></fa-icon></label>
                        </div>
                        <div class="list-input-content">
                          <app-text-input #txti_ListingGoodsName id="txti_ListingGoodsName"
                            [subid]="'txti_ListingGoodsName'" [restrict]="'[ -￮]'" [maxChars]="30" [tabindex]="0"
                            [displayCountField]="true" [(ngModel)]="this.kymw0900Model.listingGoodsName"
                            [fullOnly]="true" [style.width.rem]="36" >
                          </app-text-input>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <h2>表組項目一覧</h2>
                    <wj-flex-grid #dtg_ListingItemList [style.width.%]="100" [style.min-height.px]="70"
                      [style.height.%]="100" id="dtg_ListingItemList"
                      editable="true" [tabindex]="0" [itemsSource]="this.kymw0900Model.listingItemList"
                      [allowMerging]="'ColumnHeaders'" [headersVisibility]="'Column'" [frozenColumns]="1"
                      [allowSorting]="false" sortableColumns="false" rowHeight="25" [allowDragging]="'None'"
                      [selectionMode]="'Row'" [isReadOnly]="true" [allowResizing]="'Columns'"
                      (keydown)="nextFocusForReadonlyUser($event)">
                      <wj-flex-grid-column [minWidth]="5" [width]="200" [binding]="'ListingItemName'" [header]="'項目名'">
                      </wj-flex-grid-column>
                      <wj-flex-grid-column [minWidth]="5" [width]="695" [binding]="'DispContents'" [header]="'表示内容'"
                        textAlign="left">
                        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                          <input type="text" [tabindex]="0" [(ngModel)]="cell.item.DispContents" [style.width.%]="'100'"
                            plessInputTextSub [fullOnly]="true" [restrict]="'[ -￮]'" [maxlength]="25" autocomplete="off"
                            [disabled]="this.kymw0900Model.isDisabledForGrid ? true : false"
                            (change)="eventEditHandler()"
                            (keydown)="eventGridKeyDownHandler($event, dtg_ListingItemList, 1);eventGridTabKeyHandler($event, dtg_ListingItemList, 1, 3);"
                            (focus)="this.dtg_ListingItemList.select(cell.row.index, 1);" />
                        </ng-template>
                      </wj-flex-grid-column>
                    </wj-flex-grid>
                    <div>
                      <label [style.color]="'#E41F1F'">EC連携：</label>
                      <label [style.color]="'#212529'">表組</label>
                      <label [style.color]="'#E41F1F'">「適用体重」「パンツ・テープ」</label>
                      <label [style.color]="'#212529'">は、部門="07:住関連" かつ 小分類="620601:おむつ" の場合に連携される</label>
                    </div>
                  </div>
                </div>
              </wj-tab>
              <wj-tab forcedEnabledMode="true" id="cnv_MarkInfoTab" [tabindex]="0">
                <a id="a_MarkInfo" #a_MarkInfo>マーク</a>
                <div class="column-list">
                  <!-- マーク情報 -->
                  <div class="list-input-title layout_balance">
                    <label>マーク情報</label>
                    <label aria-label="誌面" data-microtip-position="bottom" role="tooltip" class="question">
                      <fa-icon [icon]="iconQuestion"></fa-icon></label>
                  </div>
                  <div class="list-input-content">
                    <wj-flex-grid #dtg_MarkList [style.width.px]="804" [style.height.px]="300" id="dtg_MarkList"
                      [tabindex]="0" sortableColumns="true" editable="true" [itemsSource]="this.kymw0900Model.markList"
                      [allowDragging]="'None'" [isReadOnly]="true" [headersVisibility]="'Column'"
                      [selectionMode]="'Row'" [allowResizing]="'Columns'">
                      <wj-flex-grid-column [minWidth]="5" [width]="50" [binding]="'SelectValue'" [header]="'設定'"
                        [allowSorting]="false" [isReadOnly]="true">
                        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                          <input type="checkbox" id="SelectValue" [tabindex]="-1" [(ngModel)]="cell.item.SelectValue"
                            [disabled]="this.kymw0900Model.markFlag || this.kymw0900Model.isDisabledForGrid ? true : false "
                            (change)="updateGoodsMarkCheck($event,dtg_MarkList,dtg_SelectedMark);eventEditHandler();markInfoUpdateIconCheck($event, cell)"
                            (keydown)="nextFocus($event)" [tabindex]="-1" id="cb_mark_{{cell.row.index}}"
                            (mouseup)="$event.stopPropagation()" />
                        </ng-template>
                      </wj-flex-grid-column>
                      <wj-flex-grid-column [minWidth]="5" [width]="100" [binding]="'MarkCode'" [header]="'マークコード'"
                        [align]="'left'">
                        <ng-template>
                          <label style="text-align:center"></label>
                        </ng-template>
                      </wj-flex-grid-column>
                      <wj-flex-grid-column [minWidth]="5" [width]="635" [binding]="'MarkName'" [header]="'マーク内容'">
                      </wj-flex-grid-column>
                    </wj-flex-grid>
                  </div>
                  <!-- 選択マーク一覧 -->
                  <label class="list-input-title">選択マーク一覧</label>
                  <div class="list-input-content">
                    <wj-flex-grid #dtg_SelectedMark [style.width.px]="804" [style.height.px]="200" id="dtg_SelectedMark"
                      editable="true" variableRowHeight="true" [tabindex]="0"
                      [itemsSource]="this.kymw0900Model.selectedMarkList" [allowMerging]="'ColumnHeaders'"
                      [headersVisibility]="'Column'" [allowDragging]="'None'" [allowSorting]="false"
                      [selectionMode]="'Row'" [isReadOnly]="true" (keydown)="nextFocus($event)"
                      [allowResizing]="'Columns'" (updatingView)="onSourceChangeSelectedMark()">
                      <wj-flex-grid-column [minWidth]="5" [width]="150" [binding]="'MarkName'" [header]="'マークグループ'">
                      </wj-flex-grid-column>
                      <wj-flex-grid-column [minWidth]="5" [width]="635" [binding]="'MarkCaption'" [header]="'マーク内容'"
                        [wordWrap]=true>
                      </wj-flex-grid-column>
                    </wj-flex-grid>
                  </div>
                </div>
              </wj-tab>
              <wj-tab forcedEnabledMode="true" id="cnv_AddInfoTab" [tabindex]="0" verticalScrollPolicy="off"
                horizontalScrollPolicy="off">
                <a id="a_AddInfo" #a_AddInfo>付加</a>
                <div class="input_vertical">
                  <div class="label_input_vertical">
                    <div class="list-title_checkbox_beside">
                      <div class="list-input-title layout_balance">
                        <!-- 商品説明 -->
                        <label>商品説明</label>
                        <label aria-label="誌面＋EC" data-microtip-position="bottom" role="tooltip" class="question">
                          <fa-icon [icon]="iconQuestion"></fa-icon></label>
                      </div>
                      <div class="layout_end checkbox_btn_beside">
                        <button class="btn-secondary" id="lnb_TextInfo1" #lnb_TextInfo1 [tabindex]="0"
                          (click)="eventTextInfo1_CLICKHandler(null)">候補を表示</button>
                      </div>
                    </div>
                    <div class="list-input-content">
                      <app-text-area #txta_TextInfo1 id="txta_TextInfo1" [subid]="'txta_TextInfo1'" [restrict]="'[ -￮]'"
                        [displayCountField]="true" [maxChars]="200" [forcedEnabledMode]="'none'" [tabindex]="0"
                        [fullOnly]="true" [(ngModel)]="this.kymw0900Model.textInfo1"
                        (blur)="eventTextInfo1_FOCUS_OUTHandler(null)" [allowMultiLine]="false"
                        [height]="90">
                      </app-text-area>
                    </div>
                  </div>
                  <div class="label_input_vertical">
                    <div class="list-title_checkbox_beside">
                      <div class="list-input-title layout_balance">
                        <!-- EC用商品説明 -->
                        <label>EC用商品説明</label>
                        <label aria-label="EC" data-microtip-position="top" role="tooltip" class="question">
                          <fa-icon [icon]="iconQuestion"></fa-icon>
                        </label>
                      </div>
                      <div class="label_checkbox">
                        <label id="lbl_Explain_EC" #lbl_Explain_EC>{{kymw00Model.EXPLAIN_EC_GOODS}}</label>
                      </div>
                    </div>
                    <div class="list-input-content">
                      <app-text-area #txta_TextInfoB id="txta_TextInfoB" [subid]="'txta_TextInfoB'" [restrict]="'[ -￮]'"
                        [displayCountField]="true" [maxChars]="200" [forcedEnabledMode]="'none'" [tabindex]="0"
                        [(ngModel)]="this.kymw0900Model.textInfoB" [fullOnly]="true" [height]="90"
                        (blur)="eventTextInfoB_FOCUS_OUTHandler(null)" [allowMultiLine]="false">
                      </app-text-area>
                    </div>
                  </div>
                  <div class="label_input_vertical">
                    <div class="list-title_checkbox_beside">
                      <div class="list-input-title layout_balance">
                        <!-- キャッチコピー -->
                        <label>キャッチコピー</label>
                        <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                          <fa-icon [icon]="iconQuestion"></fa-icon></label>
                      </div>
                      <div class="layout_end checkbox_btn_beside">
                        <button class="btn-secondary" id="lnb_TextInfo2" #lnb_TextInfo2 [tabindex]="0"
                          (click)="eventTextInfo2_CLICKHandler(null)">候補を表示</button>
                      </div>
                    </div>
                    <div class="list-input-content">
                      <app-text-area #txta_TextInfo2 id="txta_TextInfo2" [subid]="'txta_TextInfo2'" [restrict]="'[ -￮]'"
                        [displayCountField]="true" [maxChars]="200" [forcedEnabledMode]="'none'" [tabindex]="0"
                        [fullOnly]="true" [(ngModel)]="this.kymw0900Model.textInfo2"
                        (blur)="eventTextInfo2_FOCUS_OUTHandler(null)" [allowMultiLine]="false"
                        [height]="90">
                      </app-text-area>
                    </div>
                  </div>
                  <div class="label_input_vertical">
                    <div class="list-title_checkbox_beside">
                      <div class="list-input-title layout_balance">
                        <!-- おすすめコメント(吹き出し) -->
                        <label>おすすめコメント(吹き出し)</label>
                        <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                          <fa-icon [icon]="iconQuestion"></fa-icon></label>
                      </div>
                      <div class="layout_end checkbox_btn_beside">
                        <button class="btn-secondary" id="lnb_TextInfo3" #lnb_TextInfo3 [tabindex]="0"
                          (click)="eventTextInfo3_CLICKHandler(null)">候補を表示</button>
                      </div>
                    </div>
                    <div class="list-input-content">
                      <app-text-area #txta_TextInfo3 id="txta_TextInfo3" [subid]="'txta_TextInfo3'" [restrict]="'[ -￮]'"
                        [displayCountField]="true" [maxChars]="200" [forcedEnabledMode]="'none'" [tabindex]="0"
                        [fullOnly]="true" [(ngModel)]="this.kymw0900Model.textInfo3"
                        (blur)="eventTextInfo3_FOCUS_OUTHandler(null)" [allowMultiLine]="false"
                        [height]="90">
                      </app-text-area>
                    </div>
                  </div>
                  <div class="label_input_vertical">
                    <div class="list-title_checkbox_beside">
                      <div class="list-input-title layout_balance">
                        <!-- 便利情報(囲み) -->
                        <label>便利情報(囲み)</label>
                        <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                          <fa-icon [icon]="iconQuestion"></fa-icon></label>
                      </div>
                    </div>
                    <div class="list-input-content">
                      <app-text-area #txta_TextInfo4 id="txta_TextInfo4" [subid]="'txta_TextInfo4'" [restrict]="'[ -￮]'"
                        [displayCountField]="true" [maxChars]="200" [forcedEnabledMode]="'none'" [tabindex]="0"
                        [fullOnly]="true" [(ngModel)]="this.kymw0900Model.textInfo4"
                        (blur)="eventTextInfo4_FOCUS_OUTHandler(null)" [allowMultiLine]="false"
                        [height]="90">
                      </app-text-area>
                    </div>
                  </div>
                  <div class="label_input_vertical">
                    <div class="list-title_checkbox_beside">
                      <div class="list-input-title layout_balance">
                        <!-- 便利情報（商品構成内容） -->
                        <label>便利情報(商品構成内容)</label>
                        <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                          <fa-icon [icon]="iconQuestion"></fa-icon></label>
                      </div>
                    </div>
                    <div class="list-input-content">
                      <app-text-area #txta_TextInfo5 id="txta_TextInfo5" [subid]="'txta_TextInfo5'" [restrict]="'[ -￮]'"
                        [displayCountField]="true" [maxChars]="200" [forcedEnabledMode]="'none'" [tabindex]="0"
                        [fullOnly]="true" [(ngModel)]="this.kymw0900Model.textInfo5"
                        (blur)="eventTextInfo5_FOCUS_OUTHandler(null)" [allowMultiLine]="false"
                        [height]="90">
                      </app-text-area>
                    </div>
                  </div>
                  <div class="label_input_vertical">
                    <div class="list-title_checkbox_beside">
                      <div class="list-input-title layout_balance">
                        <!-- 便利情報(その他) -->
                        <label>便利情報(その他)</label>
                        <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                          <fa-icon [icon]="iconQuestion"></fa-icon></label>
                      </div>
                    </div>
                    <div class="list-input-content">
                      <app-text-area #txta_TextInfo6 id="txta_TextInfo6" [subid]="'txta_TextInfo6'" [restrict]="'[ -￮]'"
                        [displayCountField]="true" [maxChars]="200" [forcedEnabledMode]="'none'" [tabindex]="0"
                        [fullOnly]="true" [(ngModel)]="this.kymw0900Model.textInfo6"
                        (blur)="eventTextInfo6_FOCUS_OUTHandler(null)" [allowMultiLine]="false"
                        [height]="90">
                      </app-text-area>
                    </div>
                  </div>
                  <div class="label_input_vertical">
                    <div class="list-title_checkbox_beside">
                      <div class="list-input-title layout_balance">
                        <!-- 便利情報(eフレンズ) -->
                        <label>便利情報(eフレンズ)</label>
                        <label aria-label="EC" data-microtip-position="top" role="tooltip" class="question">
                          <fa-icon [icon]="iconQuestion"></fa-icon></label>
                      </div>
                      <div class="label_checkbox">
                        <label id="lbl_Explain_EFriends" #lbl_Explain_EFriends>{{kymw00Model.EXPLAIN_E_FRIENDS}}</label>
                      </div>
                    </div>
                    <div class="list-input-content">
                      <app-text-area #txta_TextInfo7 id="txta_TextInfo7" [subid]="'txta_TextInfo7'" [restrict]="'[ -￮]'"
                        [displayCountField]="true" [maxChars]="200" [forcedEnabledMode]="'none'" [tabindex]="0"
                        [(ngModel)]="this.kymw0900Model.textInfo7" [fullOnly]="true" [height]="90"
                        (blur)="eventTextInfo7_FOCUS_OUTHandler(null)" [allowMultiLine]="false">
                      </app-text-area>
                    </div>
                  </div>
                  <div class="label_input_vertical">
                    <div class="list-title_checkbox_beside">
                      <div class="list-input-title layout_balance">
                        <!-- 便利情報(サイズ他) -->
                        <label>便利情報(サイズ他)</label>
                        <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                          <fa-icon [icon]="iconQuestion"></fa-icon></label>
                      </div>
                      <div class="layout_balance checkbox_btn_beside">
                        <div class="label_checkbox">
                          <label id="lbl_Explain_Size" #lbl_Explain_Size>{{kymw00Model.EXPLAIN_SIZE}}</label>
                        </div>
                        <button class="btn-secondary" id="lnb_TextInfo8" #lnb_TextInfo8 [tabindex]="0"
                          (click)="eventTextInfo8_CLICKHandler(null)">候補を表示</button>
                      </div>
                    </div>
                    <div class="list-input-content">
                      <app-text-area #txta_TextInfo8 id="txta_TextInfo8" [subid]="'txta_TextInfo8'" [restrict]="'[ -￮]'"
                        [displayCountField]="true" [maxChars]="200" [forcedEnabledMode]="'none'" [tabindex]="0"
                        enabled="true" [fullOnly]="true" [(ngModel)]="this.kymw0900Model.textInfo8"
                        (blur)="eventTextInfo8_FOCUS_OUTHandler(null)" [allowMultiLine]="false"
                        [height]="90">
                      </app-text-area>
                    </div>
                  </div>
                  <div class="label_input_vertical">
                    <div class="list-title_checkbox_beside">
                      <div class="list-input-title layout_balance">
                        <!-- 便利情報(月齢情報) -->
                        <label>便利情報(月齢情報)</label>
                        <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                          <fa-icon [icon]="iconQuestion"></fa-icon>
                        </label>
                      </div>
                      <div class="label_checkbox">
                        <label id="lbl_Explain_MonthOld" #lbl_Explain_MonthOld>{{kymw00Model.EXPLAIN_MONTH_OLD}}</label>
                      </div>
                    </div>
                    <div class="list-input-content">
                      <app-text-area #txta_TextInfoC id="txta_TextInfoC" [subid]="'txta_TextInfoC'" [restrict]="'[ -￮]'"
                        [displayCountField]="true" [maxChars]="200" [forcedEnabledMode]="'none'" [tabindex]="0"
                        enabled="true" [fullOnly]="true" [(ngModel)]="this.kymw0900Model.textInfoC"
                        (blur)="eventTextInfoC_FOCUS_OUTHandler(null)" [allowMultiLine]="false"
                        [height]="90">
                      </app-text-area>
                    </div>
                  </div>
                  <div class="label_input_vertical">
                    <div class="list-title_checkbox_beside">
                      <div class="list-input-title layout_balance">
                        <!-- 取扱注意 -->
                        <label>取扱注意</label>
                        <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                          <fa-icon [icon]="iconQuestion"></fa-icon></label>
                      </div>
                      <div class="layout_end checkbox_btn_beside">
                        <button class="btn-secondary" id="lnb_TextInfo9" #lnb_TextInfo9 [tabindex]="0"
                          (click)="eventTextInfo9_CLICKHandler(null)">候補を表示</button>
                      </div>
                    </div>
                    <div class="list-input-content">
                      <app-text-area #txta_TextInfo9 id="txta_TextInfo9" [subid]="'txta_TextInfo9'" [restrict]="'[ -￮]'"
                        [displayCountField]="true" [maxChars]="200" [forcedEnabledMode]="'none'" [tabindex]="0"
                        [fullOnly]="true" [(ngModel)]="this.kymw0900Model.textInfo9"
                        (blur)="eventTextInfo9_FOCUS_OUTHandler(null)" [allowMultiLine]="false"
                        [height]="90">
                      </app-text-area>
                    </div>
                  </div>
                  <div class="label_input_vertical">
                    <div class="list-title_checkbox_beside">
                      <div class="list-input-title layout_balance">
                        <!-- 人気商品情報 -->
                        <label>人気商品情報</label>
                        <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                          <fa-icon [icon]="iconQuestion"></fa-icon>
                        </label>
                      </div>
                      <div class="label_checkbox">
                        <label id="lbl_Explain_Popular" #lbl_Explain_EC>{{kymw00Model.EXPLAIN_POPULAR_GOODS}}</label>
                      </div>
                    </div>
                    <div class="list-input-content">
                      <app-text-area #txta_TextInfoD id="txta_TextInfoD" [subid]="'txta_TextInfoD'" [restrict]="'[ -￮]'"
                        [displayCountField]="true" [maxChars]="256" [forcedEnabledMode]="'none'" [tabindex]="0"
                        enabled="true" [fullOnly]="true" [(ngModel)]="this.kymw0900Model.textInfoD"
                        (blur)="eventTextInfoD_FOCUS_OUTHandler(null)" [allowMultiLine]="false"
                        [height]="120">
                      </app-text-area>
                    </div>
                  </div>
                  <div class="label_input_vertical">
                    <div class="list-title_checkbox_beside">
                      <div class="list-input-title layout_balance">
                        <!-- 健康管理情報 -->
                        <label>健康管理情報</label>
                        <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                          <fa-icon [icon]="iconQuestion"></fa-icon>
                        </label>
                      </div>
                      <div class="label_checkbox">
                        <label id="lbl_Explain_HealthManage" #lbl_Explain_HealthManage>{{kymw00Model.EXPLAIN_HEALTH_MANAGE}}</label>
                      </div>
                    </div>
                    <div class="list-input-content">
                      <app-text-area #txta_TextInfoE id="txta_TextInfoE" [subid]="'txta_TextInfoE'" [restrict]="'[ -￮]'"
                        [displayCountField]="true" [maxChars]="200" [forcedEnabledMode]="'none'" [tabindex]="0"
                        enabled="true" [fullOnly]="true" [(ngModel)]="this.kymw0900Model.textInfoE"
                        (blur)="eventTextInfoE_FOCUS_OUTHandler(null)" [allowMultiLine]="false"
                        [height]="90">
                      </app-text-area>
                    </div>
                  </div>
                  <div class="label_input_vertical">
                    <div class="list-title_checkbox_beside">
                      <div class="list-input-title layout_balance">
                        <!-- 成分情報 -->
                        <label>成分情報</label>
                        <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                          <fa-icon [icon]="iconQuestion"></fa-icon>
                        </label>
                      </div>
                      <div class="label_checkbox">
                        <label id="lbl_Explain_Ingredients" #lbl_Explain_Ingredients>{{kymw00Model.EXPLAIN_INGREDIENTS}}</label>
                      </div>
                    </div>
                    <div class="list-input-content">
                      <app-text-area #txta_TextInfoF id="txta_TextInfoF" [subid]="'txta_TextInfoF'" [restrict]="'[ -￮]'"
                        [displayCountField]="true" [maxChars]="2000" [forcedEnabledMode]="'none'" [tabindex]="0"
                        enabled="true" [fullOnly]="true" [(ngModel)]="this.kymw0900Model.textInfoF"
                        (blur)="eventTextInfoF_FOCUS_OUTHandler(null)" [allowMultiLine]="false"
                        [height]="90">
                      </app-text-area>
                    </div>
                  </div>
                  <div class="label_input_vertical">
                    <div class="list-title_checkbox_beside">
                      <div class="list-input-title layout_balance">
                        <!-- 吸水量 -->
                        <label>吸水量</label>
                        <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                          <fa-icon [icon]="iconQuestion"></fa-icon>
                        </label>
                      </div>
                      <div class="label_checkbox">
                        <label id="lbl_Explain_WaterAbsorption" #lbl_Explain_WaterAbsorption>{{kymw00Model.EXPLAIN_WATER_ABSORPTION}}</label>
                      </div>
                    </div>
                    <div class="list-input-content">
                      <app-text-area #txta_TextInfoG id="txta_TextInfoG" [subid]="'txta_TextInfoG'" [restrict]="'[ -￮]'"
                        [displayCountField]="true" [maxChars]="200" [forcedEnabledMode]="'none'" [tabindex]="0"
                        enabled="true" [fullOnly]="true" [(ngModel)]="this.kymw0900Model.textInfoG"
                        (blur)="eventTextInfoG_FOCUS_OUTHandler(null)" [allowMultiLine]="false"
                        [height]="90">
                      </app-text-area>
                    </div>
                  </div>
                  <div class="label_input_vertical">
                    <div class="list-title_checkbox_beside">
                      <div class="list-input-title layout_balance">
                        <!-- 調理時間の目安 -->
                        <label>調理時間の目安</label>
                        <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                          <fa-icon [icon]="iconQuestion"></fa-icon>
                        </label>
                      </div>
                      <div class="label_checkbox">
                        <label id="lbl_Explain_CookingTime" #lbl_Explain_CookingTime>{{kymw00Model.EXPLAIN_COOKING_TIME}}</label>
                      </div>
                    </div>
                    <div class="list-input-content">
                      <app-text-area #txta_TextInfoH id="txta_TextInfoH" [subid]="'txta_TextInfoH'" [restrict]="'[ -￮]'"
                        [displayCountField]="true" [maxChars]="200" [forcedEnabledMode]="'none'" [tabindex]="0"
                        enabled="true" [fullOnly]="true" [(ngModel)]="this.kymw0900Model.textInfoH"
                        (blur)="eventTextInfoH_FOCUS_OUTHandler(null)" [allowMultiLine]="false"
                        [height]="90">
                      </app-text-area>
                    </div>
                  </div>
                  <div class="label_input_vertical">
                    <div class="list-title_checkbox_beside">
                      <div class="list-input-title layout_balance">
                        <!-- 〇人前情報 -->
                        <label>〇人前情報</label>
                        <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                          <fa-icon [icon]="iconQuestion"></fa-icon>
                        </label>
                      </div>
                      <div class="label_checkbox">
                        <label id="lbl_Explain_Servings" #lbl_Explain_Servings>{{kymw00Model.EXPLAIN_SERVINGS}}</label>
                      </div>
                    </div>
                    <div class="list-input-content">
                      <app-text-area #txta_TextInfoI id="txta_TextInfoI" [subid]="'txta_TextInfoI'" [restrict]="'[ -￮]'"
                        [displayCountField]="true" [maxChars]="200" [forcedEnabledMode]="'none'" [tabindex]="0"
                        enabled="true" [fullOnly]="true" [(ngModel)]="this.kymw0900Model.textInfoI"
                        (blur)="eventTextInfoI_FOCUS_OUTHandler(null)" [allowMultiLine]="false"
                        [height]="90">
                      </app-text-area>
                    </div>
                  </div>
                  <div class="label_input_vertical">
                    <div class="list-title_checkbox_beside">
                      <div class="list-input-title layout_balance">
                        <!-- 材料 -->
                        <label>材料</label>
                        <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                          <fa-icon [icon]="iconQuestion"></fa-icon>
                        </label>
                      </div>
                      <div class="label_checkbox">
                        <label id="lbl_Explain_Material" #lbl_Explain_Material>{{kymw00Model.EXPLAIN_MATERIAL}}</label>
                      </div>
                    </div>
                    <div class="list-input-content">
                      <app-text-area #txta_TextInfoJ id="txta_TextInfoJ" [subid]="'txta_TextInfoJ'" [restrict]="'[ -￮]'"
                        [displayCountField]="true" [maxChars]="200" [forcedEnabledMode]="'none'" [tabindex]="0"
                        enabled="true" [fullOnly]="true" [(ngModel)]="this.kymw0900Model.textInfoJ"
                        (blur)="eventTextInfoJ_FOCUS_OUTHandler(null)" [allowMultiLine]="false"
                        [height]="90">
                      </app-text-area>
                    </div>
                  </div>
                  <div class="label_input_vertical">
                    <div class="list-title_checkbox_beside">
                      <div class="list-input-title layout_balance">
                        <!-- ご家庭で用意いただくもの -->
                        <label>ご家庭で用意いただくもの</label>
                        <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                          <fa-icon [icon]="iconQuestion"></fa-icon>
                        </label>
                      </div>
                      <div class="label_checkbox">
                        <label id="lbl_Explain_Preparatio" #lbl_Explain_Preparation>{{kymw00Model.EXPLAIN_PREPARATION}}</label>
                      </div>
                    </div>
                    <div class="list-input-content">
                      <app-text-area #txta_TextInfoK id="txta_TextInfoK" [subid]="'txta_TextInfoK'" [restrict]="'[ -￮]'"
                        [displayCountField]="true" [maxChars]="200" [forcedEnabledMode]="'none'" [tabindex]="0"
                        enabled="true" [fullOnly]="true" [(ngModel)]="this.kymw0900Model.textInfoK"
                        (blur)="eventTextInfoK_FOCUS_OUTHandler(null)" [allowMultiLine]="false"
                        [height]="90">
                      </app-text-area>
                    </div>
                  </div>
                  <div class="list-input-title layout_balance" style="width: 230px;">
                    <!-- バイヤーコメント -->
                    <label>バイヤーコメント</label>
                  </div>
                  <div class="list-input-content">
                    <app-text-area #txta_TextInfoA id="txta_TextInfoA" [subid]="'txta_TextInfoA'" [restrict]="'[ -￮]'"
                      [displayCountField]="true" [maxChars]="256" [tabindex]="0" [fullOnly]="true"
                      [forcedEnabledMode]="'none'" [(ngModel)]="this.kymw0900Model.textInfoA"
                      (keydown)="nextFocus($event)" [allowMultiLine]="false" [height]="112">
                    </app-text-area>
                  </div>
                </div>
              </wj-tab>
              <wj-tab forcedEnabledMode="true" id="cnv_DivInfoTab" [tabindex]="0">
                <a id="a_DivInfo" #a_DivInfo (keydown)="nextFocusForReadonlyUser($event)">発注・業態</a>
                <div class="column-list">
                  <label class="list-input-title">臭い商品区分</label>
                  <div class="list-input-content">
                    <app-code-combo-box #cmb_StinkGoodsDivList id="cmb_StinkGoodsDivList"
                      [subid]="'cmb_StinkGoodsDivList'" [codeDiv]="'ct110'" [tabindex]="0"
                      [labelField]="'codeValueName'" [blank]="false" [(ngModel)]="this.kymw0900Model.stinkGoodsDiv">
                    </app-code-combo-box>
                  </div>
                  <label class="list-input-title">ケース供給区分</label>
                  <div class="list-input-content">
                    <app-code-combo-box #cmb_CaseSupplyDivList [codeDiv]="'ct065'" [forcedEnabledMode]="'none'"
                      id="cmb_CaseSupplyDivList" [subid]="'cmb_CaseSupplyDivList'" [tabindex]="0" [blank]="false"
                      [labelField]="'codeValueName'" [(ngModel)]="this.kymw0900Model.caseSupplyDiv">
                    </app-code-combo-box>
                  </div>
                  <label class="list-input-title">長期保存区分</label>
                  <div class="list-input-content">
                    <app-code-combo-box #cmb_LongKeepDivList id="cmb_LongKeepDivList" [subid]="'cmb_LongKeepDivList'"
                      [codeDiv]="'ct102'" [tabindex]="0" [labelField]="'codeValueName'" [blank]="false"
                      [(ngModel)]="this.kymw0900Model.longKeepDiv">
                    </app-code-combo-box>
                  </div>
                  <label class="list-input-title">入荷場所区分</label>
                  <div class="list-input-content">
                    <app-code-combo-box #cmb_ArrivalAreaDivList id="cmb_ArrivalAreaDivList"
                      [subid]="'cmb_ArrivalAreaDivList'" [codeDiv]="'ct212'"
                      class="combo-box-required" [tabindex]="0" [required]="true" [blank]="true"
                      [labelField]="'codeValueName'" [(ngModel)]="this.kymw0900Model.arrivalAreaDiv">
                    </app-code-combo-box>
                  </div>
                  <label class="list-input-title">入荷許可品温</label>
                  <div class="list-input-content">
                    <input type="text" #txti_ArrivalGoodsTemp id="cmb_ArrivalAreaDivList" id="txti_ArrivalGoodsTemp"
                      [tabindex]="0" plessInputTextSub [restrict]="'[\-0-9]'" [maxlength]="3"
                      [(ngModel)]="this.kymw0900Model.arrivalGoodsTemp" [style.width.rem]="4">
                  </div>
                  <label class="list-input-title">入荷管理日数</label>
                  <div class="list-input-content">
                    <input #txti_ArrivalAdminDays type="text" id="txti_ArrivalAdminDays" [tabindex]="0"
                      plessInputTextSub [restrict]="'[0-9]'" [maxlength]="3"
                      [(ngModel)]="this.kymw0900Model.arrivalAdminDays" [style.width.rem]="4">
                  </div>
                  <label class="list-input-title">業態区分（デイリー）</label>
                  <div class="list-input-content">
                    <app-code-combo-box #cmb_DutiesFormDailyDiv  id="cmb_DutiesFormDailyDiv"
                      [subid]="'cmb_DutiesFormDailyDiv'" [codeDiv]="'ctp123'" [blank]="false" [tabindex]="0"
                      [labelField]="'codeValueName'" 
                      [(ngModel)]="this.kymw0900Model.dutiesFormDailyDiv" (keydown)="nextFocus($event)"
                      (change)="eventDailyDiv_CHANGEHandler($event)">
                    </app-code-combo-box>
                  </div>
                  <label class="list-input-title">業態区分（スポット）</label>
                  <div class="list-input-content">
                    <app-code-combo-box #cmb_DutiesFormSpotDiv [disabled]="true" id="cmb_DutiesFormSpotDiv"
                      [subid]="'cmb_DutiesFormSpotDiv'" [codeDiv]="'ctp124'" [blank]="false" forcedEnabledMode="false"
                      [labelField]="'codeValueName'" [(ngModel)]="this.kymw0900Model.dutiesFormSpotDiv" [tabindex]="0">
                    </app-code-combo-box>
                  </div>
                </div>
              </wj-tab>
              <wj-tab forcedEnabledMode="true" id="cnv_InquirInfoTab" [tabindex]="0">
                <a id="a_InquirInfo" #a_InquirInfo (keydown)="nextFocusForReadonlyUser($event)">組合員</a>
                <div id="cnv_InquirInfoTab">
                  <div class="column-list label_input_vertical">
                    <label class="list-input-title" style="width: 230px;">一括反映</label>
                    <div class="list-input-content">
                      <textarea #txta_InquiryContentsAll id="txta_InquiryContentsAll" plessInputTextSub
                        [style.height.px]="75" [restrict]="'[ -￮]'"
                        [(ngModel)]="this.kymw0900Model.inquiryContentsAll"></textarea>
                      <div class="element-row">
                        <button id="btn_BatchReflectionAll" #btn_BatchReflectionAll [tabindex]="0" class="btn-secondary"
                          (click)="eventBatchReflectionAll_CLICKHandler(null)">一括反映</button>
                        <button id="btn_InquiryContentsAll" #btn_InquiryContentsAll [tabindex]="0" class="btn-secondary"
                          (click)="eventInquiryContentsAll_CLICKHandler(null)">組合員の声</button>
                      </div>
                    </div>
                  </div>
                  <hr>
                  <div class="input_vertical">
                    <div class="label_input_vertical">
                      <div class="list-title_checkbox_beside">
                        <div class="list-input-title layout_balance">
                          <label>いばらき</label>
                          <label aria-label="誌面" data-microtip-position="top" role="tooltip" class="question">
                            <fa-icon [icon]="iconQuestion"></fa-icon></label>
                        </div>
                        <div class="layout_balance checkbox_btn_beside" style="margin: 0px;">
                          <div class="label_checkbox element-row">
                            <app-checkbox-label #chk_SelectValue1 [label]="'一括反映対象'" id="chk_SelectValue1"
                              [subid]="'chk_SelectValue1'" [tabindex]="0" [(ngModel)]="this.kymw0900Model.selectValue1"
                              [disabled]="!this.kymw0900Model.selectLockArray[0]">
                            </app-checkbox-label>
                          </div>
                          <div class="element-row">
                            <button #btn_ClearContents1 id="btn_ClearContents1" [tabindex]="0" class="btn-tartiary"
                              (click)="eventClearContents1_CLICKHandler(null)"
                              [disabled]="!this.kymw0900Model.selectLockArray[0] ? 'disabled' : null "
                              (keydown)="eventInquiryContentsTabKeyHandler($event, 0)">クリア</button>
                            <button #btn_InquiryContents1 id="btn_InquiryContents1" [tabindex]="0" class="btn-secondary"
                              (click)="eventInquiryContents1_CLICKHandler(null)"
                              [disabled]="!this.kymw0900Model.selectLockArray[0] ? 'disabled' : null ">組合員の声</button>
                          </div>
                        </div>
                      </div>
                      <div class="list-input-content">
                        <textarea #txta_InquiryContents1 id="txta_InquiryContents1"
                          editable="false" [disabled]="true" plessInputTextSub [restrict]="'[ -￮]'" [style.height.px]="75"
                          [(ngModel)]="this.kymw0900Model.inquiryContentsArray[0]" [style.width.%]="100"></textarea>
                      </div>
                    </div>
                    <div class="label_input_vertical">
                      <div class="list-title_checkbox_beside">
                        <div class="list-input-title layout_balance">
                          <label>とちぎ</label>
                          <label aria-label="誌面" data-microtip-position="top" role="tooltip" class="question">
                            <fa-icon [icon]="iconQuestion"></fa-icon></label>
                        </div>
                        <div class="layout_balance checkbox_btn_beside" style="margin: 0px;">
                          <div class="label_checkbox element-row">
                            <app-checkbox-label #chk_SelectValue2 [label]="'一括反映対象'" id="chk_SelectValue2"
                              [subid]="'chk_SelectValue2'" [tabindex]="0" [(ngModel)]="this.kymw0900Model.selectValue2"
                              [disabled]="!this.kymw0900Model.selectLockArray[1]">
                            </app-checkbox-label>
                          </div>
                          <div class="element-row">
                            <button #btn_ClearContents2 id="btn_ClearContents2" [tabindex]="0" class="btn-tartiary"
                              (click)="eventClearContents2_CLICKHandler(null)"
                              [attr.disabled]="!this.kymw0900Model.selectLockArray[1] ? 'disabled' : null "
                              (keydown)="eventInquiryContentsTabKeyHandler($event, 1)">クリア</button>
                            <button #btn_InquiryContents2 id="btn_InquiryContents2" [tabindex]="0" class="btn-secondary"
                              (click)="eventInquiryContents2_CLICKHandler(null)"
                              [disabled]="!this.kymw0900Model.selectLockArray[1] ? 'disabled' : null ">組合員の声</button>
                          </div>
                        </div>
                      </div>
                      <div class="list-input-content">
                        <textarea #txta_InquiryContents2 id="txta_InquiryContents2"
                          editable="false" [disabled]="true" plessInputTextSub [restrict]="'[ -￮]'" [style.height.px]="75"
                          [(ngModel)]="this.kymw0900Model.inquiryContentsArray[1]" [style.width.%]="100"></textarea>
                      </div>
                    </div>
                    <div class="label_input_vertical">
                      <div class="list-title_checkbox_beside">
                        <div class="list-input-title layout_balance">
                          <label>ぐんま</label>
                          <label aria-label="誌面" data-microtip-position="top" role="tooltip" class="question">
                            <fa-icon [icon]="iconQuestion"></fa-icon></label>
                        </div>
                        <div class="layout_balance checkbox_btn_beside" style="margin: 0px;">
                          <div class="label_checkbox element-row">
                            <app-checkbox-label #chk_SelectValue3 [label]="'一括反映対象'" id="chk_SelectValue3"
                              [subid]="'chk_SelectValue3'" [tabindex]="0" [(ngModel)]="this.kymw0900Model.selectValue3"
                              [disabled]="!this.kymw0900Model.selectLockArray[2]">
                            </app-checkbox-label>
                          </div>
                          <div class="element-row">
                            <button #btn_ClearContents3 id="btn_ClearContents3" [tabindex]="0" class="btn-tartiary"
                              (click)="eventClearContents3_CLICKHandler(null)"
                              [disabled]="!this.kymw0900Model.selectLockArray[2] ? 'disabled' : null "
                              (keydown)="eventInquiryContentsTabKeyHandler($event, 2)">クリア</button>
                            <button #btn_InquiryContents3 id="btn_InquiryContents3" [tabindex]="0" class="btn-secondary"
                              (click)="eventInquiryContents3_CLICKHandler(null)"
                              [disabled]="!this.kymw0900Model.selectLockArray[2] ? 'disabled' : null ">組合員の声</button>
                          </div>
                        </div>
                      </div>
                      <div class="list-input-content">
                        <textarea #txta_InquiryContents3 id="txta_InquiryContents3"
                          editable="false" [disabled]="true" plessInputTextSub [restrict]="'[ -￮]'" [style.height.px]="75"
                          [(ngModel)]="this.kymw0900Model.inquiryContentsArray[2]" [style.width.%]="100"></textarea>
                      </div>
                    </div>
                    <div class="label_input_vertical">
                      <div class="list-title_checkbox_beside">
                        <div class="list-input-title layout_balance">
                          <label>ちば</label>
                          <label aria-label="誌面" data-microtip-position="top" role="tooltip" class="question">
                            <fa-icon [icon]="iconQuestion"></fa-icon></label>
                        </div>
                        <div class="layout_balance checkbox_btn_beside" style="margin: 0px;">
                          <div class="label_checkbox element-row">
                            <app-checkbox-label #chk_SelectValue4 [label]="'一括反映対象'" id="chk_SelectValue4"
                              [subid]="'chk_SelectValue4'" [tabindex]="0" [(ngModel)]="this.kymw0900Model.selectValue4"
                              [disabled]="!this.kymw0900Model.selectLockArray[3]">
                            </app-checkbox-label>
                          </div>
                          <div class="element-row">
                            <button #btn_ClearContents4 id="btn_ClearContents4" [tabindex]="0" class="btn-tartiary"
                              (click)="eventClearContents4_CLICKHandler(null)"
                              [disabled]="!this.kymw0900Model.selectLockArray[3] ? 'disabled' : null "
                              (keydown)="eventInquiryContentsTabKeyHandler($event, 3)">クリア</button>
                            <button #btn_InquiryContents4 id="btn_InquiryContents4" [tabindex]="0" class="btn-secondary"
                              (click)="eventInquiryContents4_CLICKHandler(null)"
                              [disabled]="!this.kymw0900Model.selectLockArray[3] ? 'disabled' : null ">組合員の声</button>
                          </div>
                        </div>
                      </div>
                      <div class="list-input-content">
                        <textarea #txta_InquiryContents4 id="txta_InquiryContents4"
                          editable="false" [disabled]="true" plessInputTextSub [restrict]="'[ -￮]'" [style.height.px]="75"
                          [(ngModel)]="this.kymw0900Model.inquiryContentsArray[3]" [style.width.%]="100"></textarea>
                      </div>
                    </div>
                    <div class="label_input_vertical">
                      <div class="list-title_checkbox_beside">
                        <div class="list-input-title layout_balance">
                          <label>さいたま</label>
                          <label aria-label="誌面" data-microtip-position="top" role="tooltip" class="question">
                            <fa-icon [icon]="iconQuestion"></fa-icon></label>
                        </div>
                        <div class="layout_balance checkbox_btn_beside" style="margin: 0px;">
                          <div class="label_checkbox element-row">
                            <app-checkbox-label #chk_SelectValue5 [label]="'一括反映対象'" id="chk_SelectValue5"
                              [subid]="'chk_SelectValue5'" [tabindex]="0" [(ngModel)]="this.kymw0900Model.selectValue5"
                              [disabled]="!this.kymw0900Model.selectLockArray[4]">
                            </app-checkbox-label>
                          </div>
                          <div class="element-row">
                            <button #btn_ClearContents5 id="btn_ClearContents5" [tabindex]="0" class="btn-tartiary"
                              (click)="eventClearContents5_CLICKHandler(null)"
                              [disabled]="!this.kymw0900Model.selectLockArray[4] ? 'disabled' : null "
                              (keydown)="eventInquiryContentsTabKeyHandler($event, 4)">クリア</button>
                            <button #btn_InquiryContents5 id="btn_InquiryContents5" [tabindex]="0" class="btn-secondary"
                              (click)="eventInquiryContents5_CLICKHandler(null)"
                              [disabled]="!this.kymw0900Model.selectLockArray[4] ? 'disabled' : null ">組合員の声</button>
                          </div>
                        </div>
                      </div>
                      <div class="list-input-content">
                        <textarea #txta_InquiryContents5 id="txta_InquiryContents5"
                          editable="false" [disabled]="true" plessInputTextSub [restrict]="'[ -￮]'" [style.height.px]="75"
                          [(ngModel)]="this.kymw0900Model.inquiryContentsArray[4]" [style.width.%]="100"></textarea>
                      </div>
                    </div>
                    <div class="label_input_vertical">
                      <div class="list-title_checkbox_beside">
                        <div class="list-input-title layout_balance">
                          <label>とうきょう</label>
                          <label aria-label="誌面" data-microtip-position="top" role="tooltip" class="question">
                            <fa-icon [icon]="iconQuestion"></fa-icon></label>
                        </div>
                        <div class="layout_balance checkbox_btn_beside" style="margin: 0px;">
                          <div class="label_checkbox element-row">
                            <app-checkbox-label #chk_SelectValue6 [label]="'一括反映対象'" id="chk_SelectValue6"
                              [subid]="'chk_SelectValue6'" [tabindex]="0" [(ngModel)]="this.kymw0900Model.selectValue6"
                              [disabled]="!this.kymw0900Model.selectLockArray[5]">
                            </app-checkbox-label>
                          </div>
                          <div class="element-row">
                            <button #btn_ClearContents6 id="btn_ClearContents6" [tabindex]="0" class="btn-tartiary"
                              (click)="eventClearContents6_CLICKHandler(null)"
                              [disabled]="!this.kymw0900Model.selectLockArray[5] ? 'disabled' : null "
                              (keydown)="eventInquiryContentsTabKeyHandler($event, 5)">クリア</button>
                            <button #btn_InquiryContents6 id="btn_InquiryContents6" [tabindex]="0" class="btn-secondary"
                              (click)="eventInquiryContents6_CLICKHandler(null)"
                              [disabled]="!this.kymw0900Model.selectLockArray[5] ? 'disabled' : null ">組合員の声</button>
                          </div>
                        </div>
                      </div>
                      <div class="list-input-content">
                        <textarea #txta_InquiryContents6 id="txta_InquiryContents6"
                          plessInputTextSub [restrict]="'[ -￮]'" editable="false" [disabled]="true" [style.height.px]="75"
                          [(ngModel)]="this.kymw0900Model.inquiryContentsArray[5]" [style.width.%]="100"></textarea>
                      </div>
                    </div>
                    <div class="label_input_vertical">
                      <div class="list-title_checkbox_beside">
                        <div class="list-input-title layout_balance">
                          <label>ながの</label>
                          <label aria-label="誌面" data-microtip-position="top" role="tooltip" class="question">
                            <fa-icon [icon]="iconQuestion"></fa-icon></label>
                        </div>
                        <div class="layout_balance checkbox_btn_beside" style="margin: 0px;">
                          <div class="label_checkbox element-row">
                            <app-checkbox-label #chk_SelectValue7 [label]="'一括反映対象'" id="chk_SelectValue7"
                              [subid]="'chk_SelectValue7'" [tabindex]="0" [(ngModel)]="this.kymw0900Model.selectValue7"
                              [disabled]="!this.kymw0900Model.selectLockArray[6]">
                            </app-checkbox-label>
                          </div>
                          <div class="element-row">
                            <button #btn_ClearContents7 id="btn_ClearContents7" [tabindex]="0" class="btn-tartiary"
                              (click)="eventClearContents7_CLICKHandler(null)"
                              [disabled]="!this.kymw0900Model.selectLockArray[6] ? 'disabled' : null "
                              (keydown)="eventInquiryContentsTabKeyHandler($event, 6)">クリア</button>
                            <button #btn_InquiryContents7 id="btn_InquiryContents7" [tabindex]="0" class="btn-secondary"
                              (click)="eventInquiryContents7_CLICKHandler(null)"
                              [disabled]="!this.kymw0900Model.selectLockArray[6] ? 'disabled' : null ">組合員の声</button>
                          </div>
                        </div>
                      </div>
                      <div class="list-input-content">
                        <textarea #txta_InquiryContents7 id="txta_InquiryContents7"
                          editable="false" [disabled]="false" plessInputTextSub [restrict]="'[ -￮]'" [style.height.px]="75"
                          [(ngModel)]="this.kymw0900Model.inquiryContentsArray[6]" [style.width.%]="100"></textarea>
                      </div>
                    </div>
                    <div class="label_input_vertical">
                      <div class="list-title_checkbox_beside">
                        <div class="list-input-title layout_balance">
                          <label>にいがた</label>
                          <label aria-label="誌面" data-microtip-position="top" role="tooltip" class="question">
                            <fa-icon [icon]="iconQuestion"></fa-icon></label>
                        </div>
                        <div class="layout_balance checkbox_btn_beside" style="margin: 0px;">
                          <div class="label_checkbox element-row">
                            <app-checkbox-label #chk_SelectValue8 [label]="'一括反映対象'" id="chk_SelectValue8"
                              [subid]="'chk_SelectValue8'" [tabindex]="0" [(ngModel)]="this.kymw0900Model.selectValue8"
                              [disabled]="!this.kymw0900Model.selectLockArray[7]">
                            </app-checkbox-label>
                          </div>
                          <div class="element-row">
                            <button #btn_ClearContents8 id="btn_ClearContents8" [tabindex]="0" class="btn-tartiary"
                              (click)="eventClearContents8_CLICKHandler(null)"
                              [disabled]="!this.kymw0900Model.selectLockArray[7] ? 'disabled' : null "
                              (keydown)="eventInquiryContentsTabKeyHandler($event, 7)">クリア</button>
                            <button #btn_InquiryContents8 id="btn_InquiryContents8" [tabindex]="0" class="btn-secondary"
                              (click)="eventInquiryContents8_CLICKHandler(null)"
                              [disabled]="!this.kymw0900Model.selectLockArray[7] ? 'disabled' : null ">組合員の声</button>
                          </div>
                        </div>
                      </div>
                      <div class="list-input-content">
                        <textarea #txta_InquiryContents8 id="txta_InquiryContents8"
                          editable="false" [disabled]="true" plessInputTextSub [restrict]="'[ -￮]'" [style.height.px]="75"
                          [(ngModel)]="this.kymw0900Model.inquiryContentsArray[7]" [style.width.%]="100"></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </wj-tab>
              <wj-tab forcedEnabledMode="true" id="cnv_PlanInfoTab" [tabindex]="0">
                <a id="a_PlanInfo" #a_PlanInfo>計画数</a>
                <div class="column-list">
                  <label class="list-input-title">計画Ｐ Ｉ値</label>
                  <div class="list-input-content">
                    <input type="text" #txti_PlanPInum id="txti_PlanPInum" [tabindex]="0" [maxlength]="5"
                      plessInputTextSub [halfOnly]="true" [restrict]="'[.0-9]'"
                      [(ngModel)]="this.kymw0900Model.planPInum" [style.width.rem]="7" />
                    <button id="btn_PlanDistribution" #btn_PlanDistribution [tabindex]="0" class="btn-secondary"
                      (click)="eventPlanDistribution_CLICKHandler(null)">計画数按分</button>
                    <button id="btn_PlanAutoSetting" #btn_PlanAutoSetting [tabindex]="0" class="btn-secondary"
                      (click)="eventPlanAutoSetting_CLICKHandler(null)">計画数自動設定</button>
                  </div>
                  <label class="list-input-title">計画数一覧</label>
                  <div class="list-input-content">
                    <wj-flex-grid #dtg_PlanList [style.width.px]="824" [style.height.px]="354" id="dtg_PlanList"
                      [tabindex]="0" [itemsSource]="this.kymw0900Model.planList" [headersVisibility]="'Column'"
                      [allowSorting]="false" sortableColumns="false" rowHeight="25" editable="true"
                      [allowDragging]="'None'" [allowResizing]="'Columns'" [selectionMode]="'Row'" [isReadOnly]="true"
                      (keydown)="nextFocusForReadonlyUser($event)">
                      <wj-flex-grid-column [minWidth]="5" [width]="98" [binding]="'CoopName'" [header]="'会員生協'">
                      </wj-flex-grid-column>
                      <wj-flex-grid-column [minWidth]="5" [width]="160" [binding]="'PlanNumAiPrediction'" [header]="'計画数(予測)'"
                        [align]="'right'">
                        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                          <div class="align-right" [style.width.%]="'100'">
                            {{cell.item.PlanNumAiPrediction}}
                          </div>
                        </ng-template>
                      </wj-flex-grid-column>
                      <wj-flex-grid-column [minWidth]="5" [width]="183" [binding]="'Plannum'" [header]="'計画数(修正)'"
                        [align]="'right'">
                        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                          <input type="text" plessInputTextSub [restrict]="'[0-9]'" value="{{cell.item.Plannum}}"
                            [maxlength]="7" class="align-right" [style.width.%]="'100'"
                            [(ngModel)]="cell.item.Plannum" [tabindex]="0" autocomplete="off"
                            (blur)="eventPlanNumChange($event)" (change)="eventEditHandler()"
                            [disabled]="cell.item.Enabled !='1' || this.kymw0900Model.isDisabledForGrid ? true : false "
                            (keydown)="eventGridKeyDownHandler($event,dtg_PlanList,1)"
                            (focus)="this.dtg_PlanList.select(cell.row.index, -1);" />
                        </ng-template>
                      </wj-flex-grid-column>
                      <wj-flex-grid-column [minWidth]="5" [width]="183" [binding]="'LimitnumTotal'"
                        [header]="'限定数量総数'" [align]="'right'">
                        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                          <input type="text" value="{{cell.item.LimitnumTotal}}" [maxlength]="7" disabled="true"
                            *ngIf="cell.row.index==0" class="align-right" [style.width.%]="'100'" autocomplete="off"
                            [(ngModel)]="cell.item.LimitnumTotal" />
                          <input type="text" plessInputTextSub [restrict]="'[0-9]'"
                            value="{{cell.item.LimitnumTotal}}" [maxlength]="7" *ngIf="cell.row.index!=0"
                            class="align-right" [style.width.%]="'100'" [(ngModel)]="cell.item.LimitnumTotal"
                            autocomplete="off" (blur)="eventPlanNumChange($event)" (change)="eventEditHandler()"
                            [disabled]="cell.item.Enabled !='1' || this.kymw0900Model.isDisabledForGrid ? true : false "
                            (keydown)="eventGridKeyDownHandler($event,dtg_PlanList,2)" />
                        </ng-template>
                      </wj-flex-grid-column>
                      <wj-flex-grid-column [minWidth]="5" [width]="183" [binding]="'LimitnumPerson'"
                        [header]="'限定数量個人'" [align]="'right'">
                        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                          <input type="text" value="{{cell.item.LimitnumPerson}}" [maxlength]="7" disabled="true"
                            *ngIf="cell.row.index==0" class="align-right" [style.width.%]="'100'" autocomplete="off"
                            [(ngModel)]="cell.item.LimitnumPerson" />
                          <input type="text" value="{{cell.item.LimitnumPerson}}" plessInputTextSub
                            [restrict]="'[0-9]'" [maxlength]="7" *ngIf="cell.row.index!=0" class="align-right"
                            [style.width.%]="'100'" [(ngModel)]="cell.item.LimitnumPerson" autocomplete="off"
                            [tabindex]="0"
                            [disabled]="cell.item.Enabled !='1' || this.kymw0900Model.isDisabledForGrid ? true : false "
                            (blur)="eventPlanNumChange($event)" (change)="eventEditHandler()"
                            (keydown)="eventGridKeyDownHandler($event,dtg_PlanList,3);eventGridTabKeyHandler($event, dtg_PlanList, 3, 8);" />
                        </ng-template>
                      </wj-flex-grid-column>
                    </wj-flex-grid>
                  </div>
                </div>
              </wj-tab>
              <wj-tab forcedEnabledMode="true" id="cnv_GuideInfoTab" [tabindex]="0">
                <a id="a_GuideInfo" #a_GuideInfo>案内</a>
                <div>
                  <h2>案内一覧</h2>
                  <div class="element-column">
                    <button id="btn_SettingNextGuide" #btn_SettingNextGuide [tabindex]="0" class="btn-secondary"
                      (click)="eventSettingNextGuide_CLICKHandler(null)">次回案内自動設定</button>
                    <wj-flex-grid #dtg_GuideList id="dtg_GuideList" [tabindex]="0" [allowSorting]="false"
                      [style.width.%]="100" [itemsSource]="this.kymw0900Model.guideList"
                      [headersVisibility]="'Column'" [allowDragging]="'None'" sortableColumns="false" rowHeight="25"
                      editable="true" [selectionMode]="'Row'" [isReadOnly]="true" [allowResizing]="'Columns'"
                      [frozenColumns]="2" (keydown)="nextFocusForReadonlyUser($event)">
                      <wj-flex-grid-column [minWidth]="5" [width]="83" [binding]="'CoopName'" [header]="'会員生協'">
                      </wj-flex-grid-column>
                      <wj-flex-grid-column [minWidth]="5" [width]="85" [binding]="'OrderNum'" [header]="'注文コード'">
                      </wj-flex-grid-column>
                      <wj-flex-grid-column [minWidth]="5" [width]="180" [binding]="'AppearDiv'" [header]="'登場区分'"
                        [align]="'left'">
                        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                          <select #cmb_AppearDiv id="cmb_AppearDiv" [style.width.%]="'100'"
                            [(ngModel)]="cell.item.AppearDiv" [disabled]="isDisabledAppearDiv(cell, cmb_AppearDiv)"
                            [tabindex]="-1" (change)="eventEditHandler()">
                            <ng-template ngFor let-item [ngForOf]="this.kymw0900Model.appearDivList">
                              <option value="{{item.CodeValue}}">{{item.CodeValueName}}</option>
                            </ng-template>
                          </select>
                        </ng-template>
                      </wj-flex-grid-column>
                      <ng-template ngFor let-el [ngForOf]="this.kymw0900Model.nextGuideMediumTypeList">
                        <wj-flex-grid-column [header]="el.MediumTypeName" [width]="this.kymw0900Model.nextGuideMediumTypeList.length < 2 ? 563: 282" [isReadOnly]="true" [minWidth]="5">
                          <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                            <div class="layout_balance">
                              <span>次回案内({{el.MediumTypeName}})</span>
                              <label *ngIf="el.MediumType === 'EC0'" aria-label="EC" data-microtip-position="left" role="tooltip" class="question">
                                <fa-icon [icon]="iconQuestion"></fa-icon></label>
                              <label *ngIf="el.MediumType !== 'EC0'" aria-label="誌面" data-microtip-position="left" role="tooltip" class="question">
                                <fa-icon [icon]="iconQuestion"></fa-icon></label>
                            </div>
                          </ng-template>
                          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                            <input *ngIf="el.MediumType === 'EC0'" type="text" plessInputTextSub value="{{cell.item.NextGuideMap[el.MediumType]}}"
                              [style.width.%]="'100'"  [restrict]="'[ -￮]'"
                              [(ngModel)]="cell.item.NextGuideMap[el.MediumType]" [tabindex]="0" autocomplete="off"
                              [disabled]="!this.getEnabledNextGuideEC(cell.item.CoopCode, el.MediumType) || this.kymw0900Model.isDisabledForGrid || this.kymw0900Model.stockLimitFlg"
                              (change)="eventEditHandler();eventNextGuide_FOCUSOUTHandler($event, cell, el.MediumType)" />
                            <input *ngIf="el.MediumType !== 'EC0'" type="text" plessInputTextSub value="{{cell.item.NextGuideMap[el.MediumType]}}"
                              [style.width.%]="'100'"  [restrict]="'[ -￮]'"
                              [(ngModel)]="cell.item.NextGuideMap[el.MediumType]" [tabindex]="0" autocomplete="off"
                              [disabled]="!this.getEnabledCoop(cell.item.CoopCode) || this.kymw0900Model.isDisabledForGrid || this.kymw0900Model.stockLimitFlg"
                              (change)="eventEditHandler();eventNextGuide_FOCUSOUTHandler($event, cell, el.MediumType)" />
                          </ng-template>
                        </wj-flex-grid-column>
                      </ng-template>
                    </wj-flex-grid>
                  </div>
                </div>
              </wj-tab>
              <wj-tab forcedEnabledMode="true" id="cnv_HealthPromotionTab" [tabindex]="0">
                <a id="a_HealthPromotion" #a_HealthPromotion>保健機能</a>
                <div id="cnv_HealthPromotionTab" class="element-column">
                  <div class="column-list">
                    <div class="list-input-title">
                      <label>届出番号</label>
                      <label aria-label="EC" data-microtip-position="bottom" role="tooltip" class="question">
                        <fa-icon [icon]="iconQuestion"></fa-icon></label>
                    </div>
                    <div class="list-input-content">
                      <app-text-input #txta_LicencedNo id="txta_LicencedNo" [subid]="'txta_LicencedNo'"
                        [restrict]="'[ -￮]'" [displayCountField]="true" [maxChars]="10" [forcedEnabledMode]="'none'"
                        [tabindex]="0" [width]="'13rem'" [disabled]="false" [fullOnly]="true"
                        [(ngModel)]="this.kymw0900Model.licencedNo">
                      </app-text-input>
                    </div>
                  </div>
                  <div class="input_vertical">
                    <div class="list-title_checkbox_beside">
                      <div class="list-input-title layout_balance">
                        <label>届出表示･許可表示</label>
                        <label aria-label="誌面＋EC" data-microtip-position="bottom" role="tooltip" class="question">
                          <fa-icon [icon]="iconQuestion"></fa-icon></label>
                      </div>
                      <div class="layout_end checkbox_btn_beside">
                        <button class="btn-secondary" id="lnb_LicencedDescription" #lnb_LicencedDescription
                          forcedEnabledMode="none" [tabindex]="0"
                          (click)="eventLicencedDescription_CLICKHandler(null)">候補を表示</button>
                      </div>
                    </div>
                    <div class="list-input-content element-column">
                      <app-text-area #txta_LicencedDescription id="txta_LicencedDescription"
                        [subid]="'txta_LicencedDescription'" [restrict]="'[ -￮]'" [maxChars]="400"
                        [displayCountField]="true" [tabindex]="0" [forcedEnabledMode]="'none'" [fullOnly]="true"
                        [(ngModel)]="this.kymw0900Model.licencedDescription" [allowMultiLine]="false" [height]="155">
                      </app-text-area>
                      <app-text-area #txta_LicencedDescriptionDef id="txta_LicencedDescriptionDef"
                        [subid]="'txta_LicencedDescriptionDef'" [height]="51" [width]="866" [displayCountField]="false"
                        [fullOnly]="true" [disabled]="true" [editable]="false"
                        [(ngModel)]="this.kymw0900Model.licencedDescriptionDef" 
                        [height]="90" [tabindex]="-1">
                      </app-text-area>
                    </div>
                  </div>
                </div>
              </wj-tab>
              <wj-tab forcedEnabledMode="true" id="cnv_PromotionInfoSettingTab" [tabindex]="0">
                <a id="a_PromotionInfoSetting" #a_PromotionInfoSetting>プロモ設定</a>
                <div class="contents-area">
                  <div class="element-column">
                    <wj-accordion [isAnimated]="false" [allowCollapseAll]="true" [allowExpandMany]="true">
                      <wj-accordion-pane #acc_UseLotteryPromotion id="acc_UseLotteryPromotion">
                        <div>
                          抽選商品プロモーション
                        </div>
                        <div>
                          <div class="element-column" id="useLotteryPromotionArea">
                            <app-checkbox-label #chk_UseLotteryPromotion [label]="'このプロモーション設定を使用する'" id="chk_UseLotteryPromotion"
                              style="width: max-content;"
                              [subid]="'chk_UseLotteryPromotion'" [tabindex]="0" [(ngModel)]="this.kymw0900Model.lotteryPromotionFlg"
                              (change)="eventUseLotteryPromotion_CHANGEHandler($event)" >
                            </app-checkbox-label>
                            <button #btn_WinningGoodsNumDistribution id="btn_WinningGoodsNumDistribution"
                            class="btn-secondary" [tabindex]="0" (click)="eventWinningGoodsNumDistribution_CLICKHandler();eventEditHandler();" [disabled]="!kymw0900Model.lotteryPromotionFlg || kymw0900Model.permission === '1'">
                              曜日別当選数自動振分</button>
                            <wj-flex-grid #dtg_UseLotteryPromotionList [style.width.%]="100" [style.height.px]="225"
                              id="dtg_UseLotteryPromotionList" [tabindex]="0" [itemsSource]="this.kymw0900Model.planGoodsLotteryList"
                              [selectionMode]="'Row'" [headersVisibility]="'Column'" [allowDragging]="'None'"
                              sortableColumns="false" rowHeight="50" editable="true" [allowSorting]="false"
                              [isReadOnly]="true" [allowResizing]="'Columns'" [frozenColumns]="4" forcedEnabledMode="true">
                              <wj-flex-grid-column [minWidth]="5" [width]="40" [header]="' '" [binding]="''" [align]="'center'" [isReadOnly]="true">
                                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                  <div>
                                    <input id="use_lottery_promotion_list_check_{{cell.row.index}}"
                                      type="checkbox" [(ngModel)]="cell.item.check" (change)="kymw0900Model.lotteryList_CHECKHandler(cell.item, $event);eventEditHandler();" 
                                      [tabindex]="-1" [disabled]="!kymw0900Model.lotteryPromotionFlg || this.kymw0900Model.isDisabledForGrid" (mouseup)="$event.stopPropagation()"/>
                                  </div>
                                </ng-template>
                              </wj-flex-grid-column>
                              <wj-flex-grid-column [minWidth]="5" [width]="100" [binding]="'itemCode'" [header]="'アイテムコード'">
                              </wj-flex-grid-column>
                              <wj-flex-grid-column [minWidth]="5" [width]="100" [multiLine]="true" [binding]="'winningGoodsNum'" [header]="'抽選商品\n当選数'" [align]="'right'">
                                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                  <input type="text" plessInputTextSub value="{{cell.item.winningGoodsNum}}"
                                    [style.width.%]="'100'" [maxlength]="7" [restrict]="'[0-9]'" style="text-align:right;"
                                    [(ngModel)]="cell.item.winningGoodsNum" [tabindex]="0" autocomplete="off"
                                    [disabled]="!kymw0900Model.lotteryPromotionFlg || !cell.item.check || this.kymw0900Model.isDisabledForGrid"
                                    (change)="eventEditHandler()" class="text-label-required"/>
                                </ng-template>
                              </wj-flex-grid-column>
                              <wj-flex-grid-column [minWidth]="5" [width]="128" [multiLine]="true" [binding]="'winningGoodsPerPersonNum'" [header]="'一人あたりの\n抽選商品当選数'" [align]="'right'">
                                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                  <input type="text" plessInputTextSub value="{{cell.item.winningGoodsPerPersonNum}}"
                                    [style.width.%]="'100'" [maxlength]="7" [restrict]="'[0-9]'" style="text-align:right;"
                                    [(ngModel)]="cell.item.winningGoodsPerPersonNum" [tabindex]="0" autocomplete="off"
                                    [disabled]="!kymw0900Model.lotteryPromotionFlg || !cell.item.check || this.kymw0900Model.isDisabledForGrid"
                                    (change)="eventEditHandler()" class="text-label-required"/>
                                </ng-template>
                              </wj-flex-grid-column>
                              <wj-flex-grid-column [minWidth]="5" [width]="230" [binding]="'limitedMeaning'" [header]="'限定のワケ'">
                                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                  <app-code-combo-box [required]="true" [codeDiv]="'ctp312'"
                                  [labelField]="'codeValueName'" [disabled]="!kymw0900Model.lotteryPromotionFlg || !cell.item.check || this.kymw0900Model.isDisabledForGrid"
                                  class="combo-box-required" [forcedEnabledMode]="'none'"
                                  [tabindex]="0" [style.width.%]="100" [(ngModel)]="cell.item.limitedMeaning"
                                  (change)="eventEditHandler()">
                                </app-code-combo-box>
                                </ng-template>
                              </wj-flex-grid-column>
                              <wj-flex-grid-column [minWidth]="5" [width]="100" [multiLine]="true" [binding] ="'mondayPlanNum'" [header]="'月曜日当選数\n(予定)'" [align]="'right'">
                                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                  <input type="text" plessInputTextSub value="{{cell.item.mondayPlanNum}}"
                                    [style.width.%]="'100'" [maxlength]="7" [restrict]="'[0-9]'" style="text-align:right;"
                                    [(ngModel)]="cell.item.mondayPlanNum" [tabindex]="0" autocomplete="off"
                                    [disabled]="!kymw0900Model.lotteryPromotionFlg || !cell.item.check || this.kymw0900Model.isDisabledForGrid"
                                    (change)="eventEditHandler()" class="text-label-required"
                                    (blur)="eventDayOfWeekPlanNum_FOCUS_OUTHandler(cell.item)"/>
                                </ng-template>
                              </wj-flex-grid-column>
                              <wj-flex-grid-column [minWidth]="5" [width]="100" [multiLine]="true" [binding]="'tuesdayPlanNum'" [header]="'火曜日当選数\n(予定)'" [align]="'right'">
                                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                  <input type="text" plessInputTextSub value="{{cell.item.tuesdayPlanNum}}"
                                    [style.width.%]="'100'" [maxlength]="7" [restrict]="'[0-9]'" style="text-align:right;"
                                    [(ngModel)]="cell.item.tuesdayPlanNum" [tabindex]="0" autocomplete="off"
                                    [disabled]="!kymw0900Model.lotteryPromotionFlg || !cell.item.check || this.kymw0900Model.isDisabledForGrid"
                                    (change)="eventEditHandler()" class="text-label-required"
                                    (blur)="eventDayOfWeekPlanNum_FOCUS_OUTHandler(cell.item)"/>
                                </ng-template>
                              </wj-flex-grid-column>
                              <wj-flex-grid-column [minWidth]="5" [width]="100" [multiLine]="true" [binding]="'wednesdayPlanNum'" [header]="'水曜日当選数\n(予定)'" [align]="'right'">
                                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                  <input type="text" plessInputTextSub value="{{cell.item.wednesdayPlanNum}}"
                                    [style.width.%]="'100'" [maxlength]="7" [restrict]="'[0-9]'" style="text-align:right;"
                                    [(ngModel)]="cell.item.wednesdayPlanNum" [tabindex]="0" autocomplete="off"
                                    [disabled]="!kymw0900Model.lotteryPromotionFlg || !cell.item.check || this.kymw0900Model.isDisabledForGrid"
                                    (change)="eventEditHandler()" class="text-label-required"
                                    (blur)="eventDayOfWeekPlanNum_FOCUS_OUTHandler(cell.item)"/>
                                </ng-template>
                              </wj-flex-grid-column>
                              <wj-flex-grid-column [minWidth]="5" [width]="100" [multiLine]="true" [binding]="'thursdayPlanNum'" [header]="'木曜日当選数\n(予定)'" [align]="'right'">
                                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                  <input type="text" plessInputTextSub value="{{cell.item.thursdayPlanNum}}"
                                    [style.width.%]="'100'" [maxlength]="7" [restrict]="'[0-9]'" style="text-align:right;"
                                    [(ngModel)]="cell.item.thursdayPlanNum" [tabindex]="0" autocomplete="off"
                                    [disabled]="!kymw0900Model.lotteryPromotionFlg || !cell.item.check || this.kymw0900Model.isDisabledForGrid"
                                    (change)="eventEditHandler()" class="text-label-required"
                                    (blur)="eventDayOfWeekPlanNum_FOCUS_OUTHandler(cell.item)"/>
                                </ng-template>
                              </wj-flex-grid-column>
                              <wj-flex-grid-column [minWidth]="5" [width]="100" [multiLine]="true" [binding]="'fridayPlanNum'" [header]="'金曜日当選数\n(予定)'" [align]="'right'">
                                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                  <input type="text" plessInputTextSub value="{{cell.item.fridayPlanNum}}"
                                    [style.width.%]="'100'" [maxlength]="7" [restrict]="'[0-9]'" style="text-align:right;"
                                    [(ngModel)]="cell.item.fridayPlanNum" [tabindex]="0" autocomplete="off"
                                    [disabled]="!kymw0900Model.lotteryPromotionFlg || !cell.item.check || this.kymw0900Model.isDisabledForGrid"
                                    (change)="eventEditHandler()" class="text-label-required"
                                    (blur)="eventDayOfWeekPlanNum_FOCUS_OUTHandler(cell.item)"/>
                                </ng-template>
                              </wj-flex-grid-column>
                            </wj-flex-grid>
                          </div>
                        </div>
                      </wj-accordion-pane>
                    </wj-accordion>

                    <wj-accordion [isAnimated]="false" [allowCollapseAll]="true" [allowExpandMany]="true">
                      <wj-accordion-pane #acc_PointPromotion id="acc_PointPromotion">
                        <div>
                          ポイント交換商品プロモーション
                        </div>
                        <div>
                          <div class="element-column" id="pointPromotionArea">
                            <app-checkbox-label #chk_PointPromotion [label]="'このプロモーション設定を使用する'" id="chk_PointPromotion"
                              [subid]="'chk_PointPromotion'" [tabindex]="0" [(ngModel)]="this.kymw0900Model.pointPromotionFlg" [disabled]="true">
                            </app-checkbox-label>
                            <div class="element-column">
                              <wj-flex-grid #dtg_PointPromotionList [style.width.%]="100" [style.height.px]="225"
                                id="dtg_PointPromotionList" [tabindex]="0" [itemsSource]="this.kymw0900Model.pointExchangeListDisplay"
                                [selectionMode]="'Row'" [headersVisibility]="'Column'" [allowDragging]="'None'"
                                sortableColumns="false" rowHeight="50" editable="true" [allowSorting]="false" [frozenColumns]="2"
                                [isReadOnly]="true" [allowResizing]="'Columns'" forcedEnabledMode="true">
                                <wj-flex-grid-column [minWidth]="5" [width]="95" [binding]="'pointExchangeOrderNum'" [header]="'ポイント交換\n注文コード'" [multiLine]="true">
                                </wj-flex-grid-column>
                                <wj-flex-grid-column [minWidth]="5" [width]="100" [binding]="'itemCode'" [header]="'アイテムコード'">
                                </wj-flex-grid-column>
                                <wj-flex-grid-column [minWidth]="5" [width]="250" [binding]="'pointExchangeGoodsName'" [header]="'専用商品名'">
                                </wj-flex-grid-column>
                                <wj-flex-grid-column [minWidth]="5" [width]="250" [binding]="'pointExchangeGuideName'" [header]="'専用規格名'">
                                </wj-flex-grid-column>
                                <wj-flex-grid-column [minWidth]="5" [width]="100" [binding]="'displayExchangePoint'" [header]="'交換ポイント'" [align]="'right'">
                                </wj-flex-grid-column>
                                <wj-flex-grid-column [minWidth]="5" [width]="100" [binding]="'displayThisTimeSupplyPrice'" [header]="'供給単価'" [align]="'right'">
                                </wj-flex-grid-column>
                              </wj-flex-grid>
                              <button id="btn_PointPromotionListAdd" forcedEnabledMode="none" class="btn-secondary" [tabindex]="0"
                              (click)="eventPointPromotionListAdd_CLICKHandler()" [disabled]="kymw0900Model.pointExchangeAddDisable">追加</button>
                            </div>
                          </div>
                        </div>
                      </wj-accordion-pane>
                    </wj-accordion>

                    <wj-accordion [isAnimated]="false" [allowCollapseAll]="true" [allowExpandMany]="true">
                      <wj-accordion-pane #acc_NvalPromotion id="acc_NvalPromotion">
                        <div>
                          1物N価媒体プロモーション
                        </div>
                        <div>
                          <div class="element-column" id="nvalPromotionArea">
                            <app-checkbox-label #chk_NvalPromotion [label]="'このプロモーション設定を使用する'" id="chk_NvalPromotion"
                              [subid]="'chk_NvalPromotion'" [tabindex]="0" [(ngModel)]="this.kymw0900Model.nvalPromotionFlg" [disabled]="true">
                            </app-checkbox-label>
                            <div class="block-row">
                              <label class="nval_bundle" style="width: 100px;padding: 0 5px;">束ね期間外</label>
                              <label class="nval_disable" style="width: 100px;padding: 0 5px;">編集不可</label>
                            </div>
                            <wj-flex-grid #dtg_NvalPromotionList [style.width.%]="100" [style.height.px]="225"
                              id="dtg_NvalPromotionList" [tabindex]="0" [itemsSource]="this.kymw0900Model.nvalPromotionListDisplay"
                              [selectionMode]="'Row'" [headersVisibility]="'Column'" [allowDragging]="'None'"
                              sortableColumns="false" rowHeight="50" editable="true" [allowSorting]="false"
                              [isReadOnly]="true" [allowResizing]="'Columns'" [frozenColumns]="4" forcedEnabledMode="true">
                              <wj-flex-grid-column [minWidth]="5" [width]="187" [binding]="'mediumTypeName'" [header]="'媒体'">
                              </wj-flex-grid-column>
                              <wj-flex-grid-column [minWidth]="5" [width]="80" [binding]="'nvalOrderNum'" [header]="'注文コード'" [align]="'right'">
                              </wj-flex-grid-column>
                              <wj-flex-grid-column [minWidth]="5" [width]="95" [binding]="'itemCode'" [header]="'アイテムコード'" [align]="'right'">
                              </wj-flex-grid-column>
                              <wj-flex-grid-column [minWidth]="5" [width]="140" [binding]="'nvalDetailId'" [header]="'1物N価詳細情報ID'" [align]="'right'"></wj-flex-grid-column>
                              <!-- 受注コード別情報 -->
                              <ng-template ngFor let-el [ngForOf]="kymw0900Model.nvalOrderCodeList">
                                <wj-flex-grid-column [header]="el" [minWidth]="5" [width]="colWidths['orderCode']" [isReadOnly]="true">
                                  <!-- ヘッダー -->
                                  <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                                    <span>{{el}}</span>
                                  </ng-template>
                                  <!-- 値引情報 -->
                                  <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                    <ng-template ngFor let-data [ngForOf]="cell.item.dataList">
                                      <div *ngIf="el === data.orderCode">{{data.displayDiscount}}</div>
                                      <div *ngIf="el !== data.orderCode"></div>
                                    </ng-template>
                                  </ng-template>
                                </wj-flex-grid-column>
                              </ng-template>
                            </wj-flex-grid>
                            <button id="btn_NvalPromotionListAdd" forcedEnabledMode="none" class="btn-secondary" [tabindex]="0"
                              (click)="eventNvalPromotionListAdd_CLICKHandler()" [disabled]="kymw0900Model.nvalAddDisable">追加</button>
                          </div>
                        </div>
                      </wj-accordion-pane>
                    </wj-accordion>

                    <wj-accordion [isAnimated]="false" [allowCollapseAll]="true" [allowExpandMany]="true">
                      <wj-accordion-pane #acc_CouponPromotion id="acc_CouponPromotion">
                        <div>
                          クーポン商品プロモーション
                        </div>
                        <div>
                          <div class="element-column" id="couponPromotionArea">
                            <app-checkbox-label #chk_CouponPromotion [label]="'このプロモーション設定を使用する'" id="chk_CouponPromotion"
                              [subid]="'chk_CouponPromotion'" [tabindex]="0" [(ngModel)]="this.kymw0900Model.couponPromotionFlg" [disabled]="true">
                            </app-checkbox-label>
                            <wj-flex-grid #dtg_CouponPromotionList [style.width.%]="100" [style.height.px]="225"
                              id="dtg_CouponPromotionList" [tabindex]="0" [itemsSource]="this.kymw0900Model.couponPromotionListDisplay"
                              [selectionMode]="'Row'" [headersVisibility]="'Column'" [allowDragging]="'None'"
                              sortableColumns="false" rowHeight="50" editable="true" [allowSorting]="false"
                              [isReadOnly]="true" [allowResizing]="'Columns'" [frozenColumns]="3" forcedEnabledMode="true">
                              <wj-flex-grid-column [minWidth]="5" [width]="100" [binding]="'couponGoodsNo'" [header]="'クーポン\n商品連番'" [multiLine]="true">
                              </wj-flex-grid-column>
                              <wj-flex-grid-column [minWidth]="5" [width]="88" [binding]="'couponOrderNum'" [header]="'クーポン\n注文コード'" [multiLine]="true">
                              </wj-flex-grid-column>
                              <wj-flex-grid-column [minWidth]="5" [width]="100" [binding]="'itemCode'" [header]="'アイテムコード'">
                              </wj-flex-grid-column>
                              <wj-flex-grid-column [minWidth]="5" [width]="170" [binding]="'couponName'" [header]="'クーポン名'"></wj-flex-grid-column>
                              <wj-flex-grid-column [minWidth]="5" [width]="170" [binding]="'couponGuideName'" [header]="'クーポン\n規格名'" [multiLine]="true">
                              </wj-flex-grid-column>
                              <wj-flex-grid-column [minWidth]="5" [width]="130" [binding]="'displayCouponType'" [header]="'クーポン種別'"></wj-flex-grid-column>
                              <wj-flex-grid-column [minWidth]="5" [width]="105" [binding]="'displayNotificationFlg'" [header]="'通知有無区分'"></wj-flex-grid-column>
                              <wj-flex-grid-column [minWidth]="5" [width]="105" [binding]="'displayDeliveryFlg'" [header]="'通知方法区分\n（お届け明細）'" [multiLine]="true"></wj-flex-grid-column>
                              <wj-flex-grid-column [minWidth]="5" [width]="105" [binding]="'displayNewsletterFlg'" [header]="'通知方法区分\n（メルマガ）'" [multiLine]="true"></wj-flex-grid-column>
                            </wj-flex-grid>
                            <button id="btn_CouponPromotionListAdd" forcedEnabledMode="none" class="btn-secondary" [tabindex]="0"
                              (click)="eventCouponPromotionListAdd_CLICKHandler()" [disabled]="kymw0900Model.couponPromotionAddDisable">追加</button>
                          </div>
                        </div>
                      </wj-accordion-pane>
                    </wj-accordion>
                  </div>
                </div>
              </wj-tab>
              <wj-tab forcedEnabledMode="true" id="cnv_TagInfoTab" [tabindex]="0">
                <a id="a_TagInfo" #a_TagInfo>タグ</a>
                <div>
                  <h1>タグ一覧</h1>
                  <wj-flex-grid #dtg_TagList id="dtg_TagList" [itemsSource]="kymw0900Model.tagList" [isReadOnly]="true"
                    style="width: 928px;height: 468px;" [allowSorting]="false" [headersVisibility]="'Column'" [allowDragging]="'None'" [selectionMode]="'Row'">
                    <wj-flex-grid-column [header]="'タググループ名'" [minWidth]="5" [width]="300" [binding]="'tagGroupName'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'タグ名'" [minWidth]="5" [width]="610" [binding]="'tagName'"></wj-flex-grid-column>
                  </wj-flex-grid>
                </div>
              </wj-tab>
              <wj-tab forcedEnabledMode="true" id="cnv_ECInfoSettingTab" [tabindex]="0">
                <a id="a_ECInfoSetting" #a_ECInfoSetting>EC設定</a>
                <div class="block-column">
                  <div class="element-column">
                    <wj-accordion [isAnimated]="false" [allowCollapseAll]="true" [allowExpandMany]="true">
                      <wj-accordion-pane #acc_stock id="acc_stock">
                        <div>在庫限定</div>
                        <div #div_stock id="div_stock">
                          <div class="block-column">
                            <div>
                              <h1>在庫数一覧</h1>
                              <div class="element-column">
                                <wj-flex-grid #dtg_StockList id="dtg_StockList" [itemsSource]="kymw0900Model.stockList" [isReadOnly]="true"
                                  style="width: 877px;" [allowSorting]="false" [headersVisibility]="'Column'" [allowDragging]="'None'" [selectionMode]="'Row'">
                                  <wj-flex-grid-column [header]="'会員生協'" [minWidth]="5" [width]="70" [binding]="'coopName'"></wj-flex-grid-column>
                                  <wj-flex-grid-column [header]="'在庫数'" [minWidth]="5" [width]="120" [binding]="'stockNum'" [align]="'right'">
                                    <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                      <input type="text" *ngIf="cell.item.coopName !== '合計'" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="7" [halfOnly]="true" [style.width.%]="'100'" [(ngModel)]="cell.item.stockNum"
                                        (change)="stockNum_CHANGEHandler()" [disabled]="!this.kymw0900Model.isEnabledCoop(cell.item.coopCode) || (this.kymw0900Model.isDisabledForGrid && !this.kymw0900Model.isConfirmed) || (this.kymw0900Model.isConfirmed && !this.kymw0900Model.isDisabledForGrid)" style="text-align:right;" />
                                      <input type="text" *ngIf="cell.item.coopName === '合計'" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="7" [halfOnly]="true" [style.width.%]="'100'" [(ngModel)]="cell.item.stockNum"
                                        style="text-align:right; background-color: rgba(0,0,0,0);" readonly/>
                                    </ng-template>
                                  </wj-flex-grid-column>
                                  <wj-flex-grid-column [header]="'通常価格'" [minWidth]="5" [width]="120" [binding]="'supplyPrice'" [align]="'right'" [isReadOnly]="true">
                                    <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                      <input type="text" *ngIf="cell.item.coopName !== '合計'" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="7" [halfOnly]="true" [style.width.%]="'100'" [(ngModel)]="cell.item.supplyPrice"
                                        (input)="supplyPrice_CHANGEHandler()" [disabled]="!this.kymw0900Model.isEnabledCoop(cell.item.coopCode) || (this.kymw0900Model.isDisabledForGrid && !this.kymw0900Model.isConfirmed) || (this.kymw0900Model.isConfirmed && !this.kymw0900Model.isDisabledForGrid)" style="text-align:right;" />
                                      <input type="text" *ngIf="cell.item.coopName === '合計'" plessInputTextSub [style.width.%]="'100'" [(ngModel)]="cell.item.supplyPrice"
                                        style="text-align:right; background-color: rgba(0,0,0,0);" readonly/>
                                    </ng-template>
                                  </wj-flex-grid-column>
                                  <wj-flex-grid-column [header]="'通常価格説明'" [minWidth]="5" [width]="550" [binding]="'supplyPriceExplanation'">
                                    <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                      <input type="text" *ngIf="cell.item.coopName !== '合計'" plessInputTextSub [restrict]="'[ -￮]'" [maxlength]="100" [style.width.%]="'100'" [(ngModel)]="cell.item.supplyPriceExplanation"
                                        (input)="supplyPriceExplanation_CHANGEHandler()" [disabled]="!this.kymw0900Model.isEnabledCoop(cell.item.coopCode) || (this.kymw0900Model.isDisabledForGrid && !this.kymw0900Model.isConfirmed) || (this.kymw0900Model.isConfirmed && !this.kymw0900Model.isDisabledForGrid)" [fullOnly]="true" />
                                      <input type="text" *ngIf="cell.item.coopName === '合計'" plessInputTextSub [restrict]="'[ -￮]'" [style.width.%]="'100'" [(ngModel)]="cell.item.supplyPriceExplanation"
                                        style="background-color: rgba(0, 0, 0, 0);" readonly/>
                                    </ng-template>
                                  </wj-flex-grid-column>
                                </wj-flex-grid>
                                <app-checkbox-label #chk_StockNumShowFlg [label]="'初期在庫数を表示しない'" id="chk_StockNumShowFlg"
                                  [subid]="'chk_StockNumShowFlg'" [tabindex]="0" [(ngModel)]="this.kymw0900Model.stockNumShowFlg">
                                </app-checkbox-label>
                                <div class="column-list">
                                  <label class="list-input-title">ブランド名(取扱注意情報を含む)</label>
                                  <div class="list-input-content">
                                    <app-text-area #txti_BrandName id="txti_BrandName" [subid]="'txti_BrandName'" [fullOnly]="true"
                                      [restrict]="'[ -￮]'" [maxChars]="400" [forcedEnabledMode]="'none'" [tabindex]="0"
                                      [displayCountField]="true" [(ngModel)]="this.kymw0900Model.brandName" [style.height.rem]="8" [style.width.rem]="48">
                                    </app-text-area>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div>
                              <h1>グルーピング</h1>
                              <div class="element-column">
                                <div class="element-row">
                                  <div class="column-list">
                                    <label class="list-input-title">グルーピング</label>
                                    <div class="list-input-content">
                                      <app-versatile-combo-box
                                        [(ngModel)]="this.kymw0900Model.groupingCode" [listSource]="this.kymw0900Model.groupingCodeList" [style.width.px]="200"
                                        valueField="GroupingCode" labelField="GroupingName" [blank]="true" [blankVal]="''" [tabindex]="0" [visible]="true"
                                        [autofocus]="false" forcedEnabledMode="none" (change)="grouping_CHANGEHandler()" [id]="'groupingCode'" #groupingCode>
                                      </app-versatile-combo-box>
                                    </div>
                                  </div>
                                  <button id="btn_ECSearch" #btn_ECSearch forcedEnabledMode="none" class="btn-secondary" [tabindex]="0"
                                    (click)="eventECSearch_CLICKHandler()">検索</button>
                                </div>
                                <wj-flex-grid #dtg_GroupingList id="dtg_GroupingList" [itemsSource]="kymw0900Model.groupingList" [isReadOnly]="true"
                                  style="width: 877px;height: 58px;" [allowSorting]="false" [headersVisibility]="'Column'" [allowDragging]="'None'" [selectionMode]="'Row'">
                                  <wj-flex-grid-column [header]="'グルーピングコード'" [minWidth]="5" [width]="120" [binding]="'groupingCode'"></wj-flex-grid-column>
                                  <wj-flex-grid-column [header]="'グルーピング名称'" [minWidth]="5" [width]="220" [binding]="'groupingName'"></wj-flex-grid-column>
                                  <wj-flex-grid-column [header]="'い'" [minWidth]="5" [width]="40" [binding]="'groupingDivIBK'" [align]="'center'"></wj-flex-grid-column>
                                  <wj-flex-grid-column [header]="'と'" [minWidth]="5" [width]="40" [binding]="'groupingDivTTG'" [align]="'center'"></wj-flex-grid-column>
                                  <wj-flex-grid-column [header]="'ぐ'" [minWidth]="5" [width]="40" [binding]="'groupingDivGNM'" [align]="'center'"></wj-flex-grid-column>
                                  <wj-flex-grid-column [header]="'ち'" [minWidth]="5" [width]="40" [binding]="'groupingDivTIB'" [align]="'center'"></wj-flex-grid-column>
                                  <wj-flex-grid-column [header]="'さ'" [minWidth]="5" [width]="40" [binding]="'groupingDivSTM'" [align]="'center'"></wj-flex-grid-column>
                                  <wj-flex-grid-column [header]="'とう'" [minWidth]="5" [width]="40" [binding]="'groupingDivTYO'" [align]="'center'"></wj-flex-grid-column>
                                  <wj-flex-grid-column [header]="'な'" [minWidth]="5" [width]="40" [binding]="'groupingDivNGN'" [align]="'center'"></wj-flex-grid-column>
                                  <wj-flex-grid-column [header]="'に'" [minWidth]="5" [width]="40" [binding]="'groupingDivNGT'" [align]="'center'"></wj-flex-grid-column>
                                  <wj-flex-grid-column [header]="'備考'" [minWidth]="5" [width]="199" [binding]="'remarks'"></wj-flex-grid-column>
                                </wj-flex-grid>
                              </div>
                            </div>
                          </div>
                        </div>
                      </wj-accordion-pane>
                    </wj-accordion>

                    <wj-accordion [isAnimated]="false" [allowCollapseAll]="true" [allowExpandMany]="true">
                      <wj-accordion-pane #acc_weblink id="acc_weblink">
                        <div>Webリンク情報</div>
                        <div>
                          <div class="element-column">
                            <div class="column-list">
                              <label class="list-input-title">コープ商品タイトル</label>
                              <div class="list-input-content">
                                <app-text-input #txti_CoopGoodsUrlTitle id="txti_CoopGoodsUrlTitle" [subid]="'txti_CoopGoodsUrlTitle'"
                                  [maxChars]="50" [forcedEnabledMode]="'none'" [tabindex]="0" [editable]="false" [disabled]="true"
                                  [displayCountField]="true" [(ngModel)]="this.kymw0900Model.coopGoodsUrlTitle" >
                                </app-text-input>
                              </div>
                              <label class="list-input-title">コープ商品URL</label>
                              <div class="list-input-content">
                                <app-text-area #txti_CoopGoodsUrl id="txti_CoopGoodsUrl" [subid]="'txti_CoopGoodsUrl'" [allowMultiLine]="true"
                                  [maxChars]="255" [forcedEnabledMode]="'none'" [tabindex]="0" [editable]="false" [disabled]="true"
                                  [displayCountField]="true" [(ngModel)]="this.kymw0900Model.coopGoodsUrl" [style.height.rem]="8">
                                </app-text-area>
                              </div>
                              <label class="list-input-title">関連情報タイトル</label>
                              <div class="list-input-content">
                                <app-text-input #txti_RelatedUrlTitle id="txti_RelatedUrlTitle" [subid]="'txti_RelatedUrlTitle'"
                                  [restrict]="'[ -￮]'" [maxChars]="50" [forcedEnabledMode]="'none'" [tabindex]="0" [fullOnly]="true"
                                  [displayCountField]="true" [(ngModel)]="this.kymw0900Model.relatedUrlTitle">
                                </app-text-input>
                              </div>
                              <label class="list-input-title">関連情報URL</label>
                              <div class="list-input-content">
                                <app-text-area #txti_RelatedUrl id="txti_RelatedUrl" [subid]="'txti_RelatedUrl'"
                                  [restrict]="'[a-zA-Z0-9@!#&amp;$%\'*+\-/=?\^_`\{\|\}~.()<>:;&quot;\\[\\]\\\\]'" [maxChars]="255"
                                  [forcedEnabledMode]="'none'" [tabindex]="0" [halfOnly]="true" [allowMultiLine]="false" 
                                  [displayCountField]="true" [(ngModel)]="this.kymw0900Model.relatedUrl" [style.height.rem]="8"
                                  (input)="eventRelatedUrl_deleteCommaHandler()"
                                  (compositionstart)="onCompStart()" (compositionend)="onCompDeleteCommaEnd($event)">
                                </app-text-area>
                              </div>
                            </div>
                          </div>
                        </div>
                      </wj-accordion-pane>
                    </wj-accordion>
                  </div>
                  <div class="element-column">
                    <div class="column-list">
                      <label class="list-input-title" [style.width.px]="100">EC連携フラグ</label>
                      <div class="list-input-content">
                        <label><input type="checkbox" #chk_CmFlg id="chk_CmFlg" [tabindex]="-1" [(ngModel)]="this.kymw0900Model.cmFlg" />広告用</label>
                        <label><input type="checkbox" #chk_RecommendFlg id="chk_RecommendFlg" [tabindex]="-1" [(ngModel)]="this.kymw0900Model.recommendFlg" />おすすめ</label>
                        <label><input type="checkbox" #chk_OrderLimitFlg id="chk_OrderLimitFlg" [tabindex]="-1" [(ngModel)]="this.kymw0900Model.orderLimitFlg" />購入限度額表示</label>
                        <label><input type="checkbox" #chk_WebLimitFlg id="chk_WebLimitFlg" [tabindex]="-1" [(ngModel)]="this.kymw0900Model.webLimitFlg" />Web限定</label>
                        <label><input type="checkbox" #chk_NonDispFlg id="chk_NonDispFlg" [tabindex]="-1" [(ngModel)]="this.kymw0900Model.nonDispFlg" />非表示</label>
                      </div>
                      <label class="list-input-title" [style.width.px]="100">注文トラン</label>
                      <div class="list-input-content">
                        <app-code-combo-box [width]="200" id="cmb_OrderGoodsDiv" #cmb_OrderGoodsDiv
                          [subid]="'cmb_OrderGoodsDiv'" [codeDiv]="'ctp054'" [labelField]="'codeValueName'" [blank]="false"
                          (change)="orderGoodsDiv_CHANGEHandler()" [tabindex]="0" [(ngModel)]="this.kymw0900Model.orderGoodsDiv">
                        </app-code-combo-box>
                      </div>
                    </div>
                    <div class="element-row">
                      <div class="column-list">
                        <label class="list-input-title" [style.width.px]="100">最低注文数</label>
                        <div class="list-input-content">
                          <input type="text" plessInputTextSub [restrict]="'[0-9]'" class="text-label-required"
                            [style.width.rem]="3" id="txti_MinOrderNum" #txti_MinOrderNum [maxlength]="3"
                            [tabindex]="0" [(ngModel)]="this.kymw0900Model.minOrderNum">
                        </div>
                      </div>
                      <div class="column-list">
                        <label class="list-input-title" [style.width.px]="100">最高注文数</label>
                        <div class="list-input-content">
                          <input type="text" plessInputTextSub [restrict]="'[0-9]'"
                            [style.width.rem]="3" id="txti_MaxOrderNum" #txti_MaxOrderNum [maxlength]="3"
                            [tabindex]="0" [(ngModel)]="this.kymw0900Model.maxOrderNum">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <h1>EC使用画像</h1>
                    <div class="element-column">
                      <button id="btn_Instructions" #btn_Instructions forcedEnabledMode="none" class="btn-secondary" [tabindex]="0"
                        (click)="eventInstructions_CLICKHandler()">指示</button>
                      <wj-flex-grid #dtg_ECImage id="dtg_ECImage" [itemsSource]="this.kymw0900Model.imageList" [allowDragging]="'None'"
                        [headersVisibility]="'None'" [selectionMode]="'Row'" [allowSorting]="false" [tabindex]="-1">
                        <wj-flex-grid-column [header]="' '" [width]="40" [binding]="'check'" [align]="'center'" [isReadOnly]="true">
                          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                            <div class="cell-center">
                              <input type="radio" id="rdb_coop_image_{{cell.row.index}}" name="rdbg_Image" [value]="cell.item.coopCode"
                                [(ngModel)]="this.kymw0900Model.selectCoopImage" [disabled]="!this.kymw0900Model.isEnabledCoop(cell.item.coopCode) || (this.kymw0900Model.isDisabledForGrid && !this.kymw0900Model.isConfirmed) || (this.kymw0900Model.isConfirmed && !this.kymw0900Model.isDisabledForGrid) || this.kymw0900Model.isEmptyCoopListItemCode(cell.item.coopCode)">
                            </div>
                          </ng-template>
                        </wj-flex-grid-column>
                        <wj-flex-grid-column [header]="' '" [width]="70" [binding]="'coopName'" [isReadOnly]="true">
                          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                            <div class="cell-center">
                              <label>{{cell.item.coopName}}</label>
                            </div>
                          </ng-template>
                        </wj-flex-grid-column>
                        <wj-flex-grid-column [header]="' '" [width]="785" [binding]="'coopImageList'" [isReadOnly]="true">
                          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                            <div class="element-row">
                              <ng-template ngFor let-item [ngForOf]="this.kymw0900Model.imageMap[cell.item.coopCode]" class="element-row"
                                *ngIf="!this.kymw0900Model.isEmptyCoopListItemCode(cell.item.coopCode)">
                                <app-image-info-renderer [data]="item"></app-image-info-renderer>
                              </ng-template>
                            </div>
                          </ng-template>
                        </wj-flex-grid-column>
                      </wj-flex-grid>
                    </div>
                  </div>
                  <app-catalog-progress-text-input id="txti_OrderCode" #txti_OrderCode [subid]="'txti_OrderCode'"
                    [forcedEnabledMode]="true" [hidden]="true" [mediumType]="this.kymw0900Model.mediumType">※企画進捗管理一覧を取得するために使用</app-catalog-progress-text-input>
                </div>
              </wj-tab>
              <wj-tab forcedEnabledMode="true" id="cnv_IconSettingTab" [tabindex]="0">
                <a id="a_IconSetting" #a_IconSetting>アイコン</a>
                <div>
                  <div>
                    <h2>アイコン情報</h2>
                    <div class="layout_end">
                      <app-checkbox-label #chk_AllCoopValueIcon [label]="'すべての生協に同一の設定'" id="chk_AllCoopValueIcon"
                        [subid]="'chk_allCoopValueIcon'" [tabindex]="0" [(ngModel)]="this.kymw0900Model.allcoopValueIcon">
                      </app-checkbox-label>
                    </div>
                  </div>
                  <!-- アイコン選択欄 -->
                  <wj-flex-grid #dtg_IconList id="dtg_IconList" [itemsSource]="this.kymw0900Model.iconList" [isReadOnly]="true" style="width: 929px;height: 250px;"
                    [allowSorting]="false" [headersVisibility]="'Column'" [allowDragging]="'None'" [selectionMode]="'Row'">
                    <wj-flex-grid-filter #fltr_Icon></wj-flex-grid-filter>
                    <wj-flex-grid-column [minWidth]="5" [width]="113" [binding]="'iconCode'" [header]="'アイコンコード'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'アイコン名'" [minWidth]="5" [width]="270" [binding]="'iconName'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'配置区分'" [minWidth]="5" [width]="89" [binding]="'arrangeDiv'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'い'" [minWidth]="5" [width]="55" [binding]="'icon0'" [align]="'center'">
                      <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                        <input type="checkbox" [(ngModel)]="cell.item.icon0" [tabindex]="-1" [disabled]="this.kymw0900Model.iconListDisable[kymw00Model.COOP_CODE_IB] || (this.kymw0900Model.isDisabledForGrid && !this.kymw0900Model.isConfirmed) || (this.kymw0900Model.isConfirmed && !this.kymw0900Model.isDisabledForGrid)" (mouseup)="$event.stopPropagation()"
                        (change)="updateIconCheck($event,dtg_IconList,dtg_SelectedIconList);eventEditHandler();"
                        (click)="checkBoxEventIconInfo($event,fltr_Icon);"
                        id="cb_icon_1_{{cell.row.index}}" />
                      </ng-template>
                    </wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'と'" [minWidth]="5" [width]="55" [binding]="'icon1'" [align]="'center'">
                      <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                        <input type="checkbox" [(ngModel)]="cell.item.icon1" [tabindex]="-1" [disabled]="this.kymw0900Model.iconListDisable[kymw00Model.COOP_CODE_TO] || (this.kymw0900Model.isDisabledForGrid && !this.kymw0900Model.isConfirmed) || (this.kymw0900Model.isConfirmed && !this.kymw0900Model.isDisabledForGrid)" (mouseup)="$event.stopPropagation()"
                        (change)="updateIconCheck($event,dtg_IconList,dtg_SelectedIconList);eventEditHandler();"
                        (click)="checkBoxEventIconInfo($event,fltr_Icon);"
                        id="cb_icon_2_{{cell.row.index}}" />
                      </ng-template>
                    </wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'ぐ'" [minWidth]="5" [width]="55" [binding]="'icon2'" [align]="'center'">
                      <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                        <input type="checkbox" [(ngModel)]="cell.item.icon2" [tabindex]="-1" [disabled]="this.kymw0900Model.iconListDisable[kymw00Model.COOP_CODE_GU] || (this.kymw0900Model.isDisabledForGrid && !this.kymw0900Model.isConfirmed) || (this.kymw0900Model.isConfirmed && !this.kymw0900Model.isDisabledForGrid)" (mouseup)="$event.stopPropagation()"
                        (change)="updateIconCheck($event,dtg_IconList,dtg_SelectedIconList);eventEditHandler();"
                        (click)="checkBoxEventIconInfo($event,fltr_Icon);"
                        id="cb_icon_3_{{cell.row.index}}" />
                      </ng-template>
                    </wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'ち'" [minWidth]="5" [width]="55" [binding]="'icon3'" [align]="'center'">
                      <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                        <input type="checkbox" [(ngModel)]="cell.item.icon3" [tabindex]="-1" [disabled]="this.kymw0900Model.iconListDisable[kymw00Model.COOP_CODE_TI] || (this.kymw0900Model.isDisabledForGrid && !this.kymw0900Model.isConfirmed) || (this.kymw0900Model.isConfirmed && !this.kymw0900Model.isDisabledForGrid)" (mouseup)="$event.stopPropagation()"
                        (change)="updateIconCheck($event,dtg_IconList,dtg_SelectedIconList);eventEditHandler();"
                        (click)="checkBoxEventIconInfo($event,fltr_Icon);"
                        id="cb_icon_4_{{cell.row.index}}" />
                      </ng-template>
                    </wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'さ'" [minWidth]="5" [width]="55" [binding]="'icon4'" [align]="'center'">
                      <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                        <input type="checkbox" [(ngModel)]="cell.item.icon4" [tabindex]="-1" [disabled]="this.kymw0900Model.iconListDisable[kymw00Model.COOP_CODE_SA] || (this.kymw0900Model.isDisabledForGrid && !this.kymw0900Model.isConfirmed) || (this.kymw0900Model.isConfirmed && !this.kymw0900Model.isDisabledForGrid)" (mouseup)="$event.stopPropagation()"
                        (change)="updateIconCheck($event,dtg_IconList,dtg_SelectedIconList);eventEditHandler();"
                        (click)="checkBoxEventIconInfo($event,fltr_Icon);"
                        id="cb_icon_5_{{cell.row.index}}" />
                      </ng-template>
                    </wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'とう'" [minWidth]="5" [width]="55" [binding]="'icon5'" [align]="'center'">
                      <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                        <input type="checkbox" [(ngModel)]="cell.item.icon5" [tabindex]="-1" [disabled]="this.kymw0900Model.iconListDisable[kymw00Model.COOP_CODE_TK] || (this.kymw0900Model.isDisabledForGrid && !this.kymw0900Model.isConfirmed) || (this.kymw0900Model.isConfirmed && !this.kymw0900Model.isDisabledForGrid)" (mouseup)="$event.stopPropagation()"
                        (change)="updateIconCheck($event,dtg_IconList,dtg_SelectedIconList);eventEditHandler();"
                        (click)="checkBoxEventIconInfo($event,fltr_Icon);"
                        id="cb_icon_6_{{cell.row.index}}" />
                      </ng-template>
                    </wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'な'" [minWidth]="5" [width]="55" [binding]="'icon6'" [align]="'center'">
                      <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                        <input type="checkbox" [(ngModel)]="cell.item.icon6" [tabindex]="-1" [disabled]="this.kymw0900Model.iconListDisable[kymw00Model.COOP_CODE_NA] || (this.kymw0900Model.isDisabledForGrid && !this.kymw0900Model.isConfirmed) || (this.kymw0900Model.isConfirmed && !this.kymw0900Model.isDisabledForGrid)" (mouseup)="$event.stopPropagation()"
                        (change)="updateIconCheck($event,dtg_IconList,dtg_SelectedIconList);eventEditHandler();"
                        (click)="checkBoxEventIconInfo($event,fltr_Icon);"
                        id="cb_icon_7_{{cell.row.index}}" />
                      </ng-template>
                    </wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'に'" [minWidth]="5" [width]="55" [binding]="'icon7'" [align]="'center'">
                      <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                        <input type="checkbox" [(ngModel)]="cell.item.icon7" [tabindex]="-1" [disabled]="this.kymw0900Model.iconListDisable[kymw00Model.COOP_CODE_NI] || (this.kymw0900Model.isDisabledForGrid && !this.kymw0900Model.isConfirmed) || (this.kymw0900Model.isConfirmed && !this.kymw0900Model.isDisabledForGrid)" (mouseup)="$event.stopPropagation()"
                        (change)="updateIconCheck($event,dtg_IconList,dtg_SelectedIconList);eventEditHandler();"
                        (click)="checkBoxEventIconInfo($event,fltr_Icon);"
                        id="cb_icon_8_{{cell.row.index}}" />
                      </ng-template>
                    </wj-flex-grid-column>
                  </wj-flex-grid>
                  <!-- アイコン選択結果表示欄 -->
                  <wj-flex-grid #dtg_SelectedIconList id="dtg_SelectedIconList" [itemsSource]="kymw0900Model.selectedIconList" [isReadOnly]="true" style="width: 929px;height: 170px;"
                    [allowSorting]="false" [headersVisibility]="'Column'" [allowDragging]="'None'" [selectionMode]="'Row'">
                    <wj-flex-grid-column [minWidth]="5" [width]="113" [binding]="'iconCode'" [header]="'アイコンコード'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'アイコン名'" [minWidth]="5" [width]="270" [binding]="'iconName'">
                      <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                        <div class="layout_balance">
                          <span>アイコン名</span>
                          <label aria-label="EC" data-microtip-position="left" role="tooltip" class="">
                            <fa-icon [icon]="iconQuestion"></fa-icon></label>
                        </div>
                      </ng-template>
                    </wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'配置区分'" [minWidth]="5" [width]="89" [binding]="'arrangeDiv'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'い'" [minWidth]="5" [width]="55" [binding]="'icon0'" [align]="'center'">
                      <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                        <input type="checkbox" [(ngModel)]="cell.item.icon0" [tabindex]="-1" [disabled]="true" />
                      </ng-template>
                    </wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'と'" [minWidth]="5" [width]="55" [binding]="'icon1'" [align]="'center'">
                      <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                        <input type="checkbox" [(ngModel)]="cell.item.icon1" [tabindex]="-1" [disabled]="true" />
                      </ng-template>
                    </wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'ぐ'" [minWidth]="5" [width]="55" [binding]="'icon2'" [align]="'center'">
                      <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                        <input type="checkbox" [(ngModel)]="cell.item.icon2" [tabindex]="-1" [disabled]="true" />
                      </ng-template>
                    </wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'ち'" [minWidth]="5" [width]="55" [binding]="'icon3'" [align]="'center'">
                      <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                        <input type="checkbox" [(ngModel)]="cell.item.icon3" [tabindex]="-1" [disabled]="true" />
                      </ng-template>
                    </wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'さ'" [minWidth]="5" [width]="55" [binding]="'icon4'" [align]="'center'">
                      <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                        <input type="checkbox" [(ngModel)]="cell.item.icon4" [tabindex]="-1" [disabled]="true" />
                      </ng-template>
                    </wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'とう'" [minWidth]="5" [width]="55" [binding]="'icon5'" [align]="'center'">
                      <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                        <input type="checkbox" [(ngModel)]="cell.item.icon5" [tabindex]="-1" [disabled]="true" />
                      </ng-template>
                    </wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'な'" [minWidth]="5" [width]="55" [binding]="'icon6'" [align]="'center'">
                      <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                        <input type="checkbox" [(ngModel)]="cell.item.icon6" [tabindex]="-1" [disabled]="true" />
                      </ng-template>
                    </wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'に'" [minWidth]="5" [width]="55" [binding]="'icon7'" [align]="'center'">
                      <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                        <input type="checkbox" [(ngModel)]="cell.item.icon7" [tabindex]="-1" [disabled]="true" />
                      </ng-template>
                    </wj-flex-grid-column>
                  </wj-flex-grid>
                </div>
              </wj-tab>
              <wj-tab [isVisible]="kymw0900Model.preOrderFlag" forcedEnabledMode="true" id="cnv_ReservationInfoSettingTab" [tabindex]="0">
                <a id="a_ReservationInfoSetting" #a_ReservationInfoSetting>予約設定</a>
                <div class="block-column">
                  <wj-flex-grid #dtg_PreOrderDetailList id="dtg_PreOrderDetailList" [itemsSource]="kymw0900Model.preOrderDetailListDisplay" [isReadOnly]="true"
                    style="width: 877px;height: 200px;" [allowSorting]="false" [headersVisibility]="'Column'" [allowDragging]="'None'" [selectionMode]="'Row'" forcedEnabledMode="true">
                    <wj-flex-grid-column [header]="'配達企画回'" [minWidth]="5" [width]="100" [binding]="'delivCatalogId'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'注文コード'" [minWidth]="5" [width]="100" [binding]="'preOrderNum'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'アイテムコード'" [minWidth]="5" [width]="100" [binding]="'itemCode'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'専用商品名'" [minWidth]="5" [width]="150" [binding]="'preOrderGoodsName'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'専用規格名'" [minWidth]="5" [width]="150" [binding]="'preOrderStandardName'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'値引前供給単価'" [minWidth]="5" [width]="115" [binding]="'supplyPriceStandard'" [align]="'right'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'値引単価'" [minWidth]="5" [width]="100" [binding]="'discountUnitPrice'" [align]="'right'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'値引率'" [minWidth]="5" [width]="100" [binding]="'discountRate'" [align]="'right'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'ポイント数'" [minWidth]="5" [width]="100" [binding]="'preOrderPoints'" [align]="'right'"></wj-flex-grid-column>
                  </wj-flex-grid>
                  <button id="btn_PreOrdeListAdd" forcedEnabledMode="none" class="btn-secondary" [tabindex]="0"
                      (click)="eventPreOrderListAdd_CLICKHandler()">追加</button>
                </div>
              </wj-tab>
            </wj-tab-panel>
          </div>
          <div class="block-column" [style.width.px]="867">
            <div>
              <h1>アイテム情報編集</h1>
              <div class="element-column">
                <div class="block-row">
                  <div class="column-list" style="width: 305px;">
                    <label class="list-input-title" style="width: 90px;">登録日</label>
                    <div class="list-input-content">
                      <input type="text" #lbl_RegistDate id="lbl_RegistDate"
                        [style.width.rem]="15" value="{{this.kymw0900Model.registDate}}" readonly>
                    </div>
                  </div>
                  <div class="column-list">
                    <label class="list-input-title" style="width: 90px;">更新日</label>
                    <div class="list-input-content">
                      <input type="text" #lbl_UpdateDate id="lbl_UpdateDate"
                        [style.width.rem]="15" value="{{this.kymw0900Model.updateDate}}" readonly>
                    </div>
                  </div>
                </div>
                <div class="column-list" style="width: 305px;">
                  <label class="list-input-title">アイテムコード</label>
                  <div class="list-input-content">
                    <select #cmb_ItemCode id="cmb_ItemCode" forcedEnabledMode="None" tabindex="0" [style.width.px]="175"
                      [(ngModel)]="this.kymw0900Model.selectedItemCode" (change)="eventItemCode_CHANGEHandler(null)">
                      <ng-template ngFor let-item [ngForOf]="this.kymw0900Model.itemCodeList">
                        <option value="{{item.ItemCode}}">{{item.ItemCode}}</option>
                      </ng-template>
                    </select>
                    <app-clipboard-copy-icon [tabindex]="0" [forcedEnabledMode]="'true'" [tooltip]="'アイテムコードをコピー'"
                      value="{{this.kymw0900Model.selectedItemCode}}"></app-clipboard-copy-icon>
                  </div>
                  <label class="list-input-title">JANコード</label>
                  <div class="list-input-content">
                    <input type="text" #txti_JanCode class="text-label-required jan-code" id="txti_JanCode" [maxlength]="13"
                      [tabindex]="0" plessInputTextSub [restrict]="'[0-9]'" enabled="true"
                      [(ngModel)]="this.kymw0900Model.janCode"/>
                    <app-checkbox-label #chk_JanCodeDiv id="chk_JanCodeDiv" [subid]="'chk_JanCodeDiv'" type="checkbox"
                      [tabindex]="0" [label]="'８桁'" [selected]="false" [(ngModel)]="this.kymw0900Model.janCodeDiv">
                    </app-checkbox-label>
                  </div>
                </div>
              </div>
            </div>
            <!-- タブ領域 -->
            <wj-tab-panel #tab_item id="tab_item" [style.background-color]="this.kymw0900Model.backgroundColor"
              (selectedTabChange)="selectedTabItemChange()">
              <wj-tab forcedEnabledMode="true" [tabindex]="0">
                <a id="a_ItemInfo" #a_ItemInfo (keydown)="nextFocusForReadonlyUser($event)">アイテム</a>
                <div class="column-list">
                  <label class="list-input-title">FC・MC手数料</label>
                  <div class="list-input-content">
                    <input type="text" #txti_FcmcFee id="txti_FcmcFee" [tabindex]="0" plessInputTextSub
                      [restrict]="'[0-9.]'" [maxlength]="7" [(ngModel)]="this.kymw0900Model.fcmcFee" [style.width.rem]="7">
                  </div>
                  <label class="list-input-title">特殊発注区分</label>
                  <div class="list-input-content">
                    <app-code-combo-box #cmb_SpecialOrderTypeList [codeDiv]="'ct216'" id="cmb_SpecialOrderTypeList"
                      [subid]="'cmb_SpecialOrderTypeList'" [blank]="false" [tabindex]="0" [labelField]="'codeValueName'"
                      [(ngModel)]="this.kymw0900Model.specialOrderType">
                    </app-code-combo-box>
                  </div>
                  <label class="list-input-title">在庫繰越区分</label>
                  <div class="list-input-content">
                    <app-code-combo-box #cmb_StockTypeList [codeDiv]="'ct115'" id="cmb_StockTypeList"
                      [subid]="'cmb_StockTypeList'" [tabindex]="0" [blank]="false" [labelField]="'codeValueName'"
                      [(ngModel)]="this.kymw0900Model.stockType">
                    </app-code-combo-box>
                  </div>
                  <label class="list-input-title">分納指定回数</label>
                  <div class="list-input-content">
                    <input type="text" #txti_InstallmentTimes id="txti_InstallmentTimes" [tabindex]="0"
                      plessInputTextSub [restrict]="'[0-9]'" [maxlength]="1"
                      [(ngModel)]="this.kymw0900Model.installmentTimes" [style.width.rem]="4">
                  </div>
                  <label class="list-input-title">物流滞留日数</label>
                  <div class="list-input-content">
                    <input type="text" #txti_PdPilingUpDays id="txti_PdPilingUpDays" [tabindex]="0" plessInputTextSub
                      [restrict]="'[0-9]'" [maxlength]="3" [(ngModel)]="this.kymw0900Model.pdPilingUpDays" [style.width.rem]="4">
                  </div>
                  <label class="list-input-title">ITFコード</label>
                  <div class="list-input-content" style="width: 11rem;">
                    <input type="text" #txti_ItfCode id="txti_ItfCode"
                      plessInputTextSub [restrict]="'[ -￮]'" [(ngModel)]="kymw0900Model.itfCode" readonly>
                  </div>
                  <label class="list-input-title">発注単位区分</label>
                  <div class="list-input-content">
                    <app-code-combo-box #cmb_OrderUnitType [codeDiv]="'ct026'" id="cmb_OrderUnitType"
                      [subid]="'cmb_OrderUnitType'" [tabindex]="0" [required]="false" [blank]="false"
                      [labelField]="'codeValueName'" [(ngModel)]="this.kymw0900Model.orderUnitType">
                    </app-code-combo-box>
                  </div>
                  <label class="list-input-title">メーカー希望小売価格(参考)</label>
                  <div class="list-input-content">
                    <app-code-combo-box #cmb_MakerType [codeDiv]="'ct291'" class="combo-box-normal" id="cmb_MakerType"
                      [subid]="'cmb_MakerType'" [tabindex]="0" [required]="false" [blank]="true"
                      [labelField]="'codeValueName'" [(ngModel)]="this.kymw0900Model.makerType">
                    </app-code-combo-box>
                    <input #txti_MakerPrice type="text" id="txti_MakerPrice" [tabindex]="0" plessInputTextSub
                      [restrict]="'[0-9]'" [maxlength]="7" [(ngModel)]="this.kymw0900Model.makerPrice" [style.width.rem]="7">
                  </div>
                  <label class="list-input-title">発注先取引先</label>
                  <div class="list-input-content">
                    <input type="text" #txti_OrderClientCode class="text-label-required" id="txti_OrderClientCode"
                      [tabindex]="0" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="6" style="width:7rem;"
                      [(ngModel)]="this.kymw0900Model.orderClientCode"
                      (blur)="eventOrderClientCode_FOCUS_OUTHandler(null)">
                    <button id="btn_OrderClientCode" class="btn-secondary" #btn_OrderClientCode [tabindex]="0"
                      (click)="eventOrderClientCode_CLICKHandler(null)">検索</button>
                    <input #txti_OrderClientName type="text" id="txti_OrderClientName"
                      plessInputTextSub [restrict]="'[ -￮]'" [(ngModel)]="this.kymw0900Model.orderClientName" readonly>
                  </div>
                  <label class="list-input-title">支払先取引先</label>
                  <div class="list-input-content">
                    <input type="text" #txti_PayeeClientCode class="text-label-required" id="txti_PayeeClientCode"
                      [tabindex]="0" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="6" style="width:7rem;"
                      [(ngModel)]="this.kymw0900Model.payeeClientCode"
                      (blur)="eventPayeeClientCode_FOCUS_OUTHandler(null)">
                    <button id="btn_PayeeClientCode" class="btn-secondary" #btn_PayeeClientCode [tabindex]="0"
                      (click)="eventPayeeClientCode_CLICKHandler(null)">検索</button>
                    <input #txti_PayeeClientName type="text" id="txti_PayeeClientName"
                      plessInputTextSub [restrict]="'[ -￮]'"
                      [(ngModel)]="this.kymw0900Model.payeeClientName" readonly>
                  </div>
                  <label class="list-input-title">価格バンドル</label>
                  <div class="list-input-content">
                    <input type="text" #txti_BundlePrice id="txti_BundlePrice" class="text-label-required"
                      [tabindex]="0" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="2"
                      [(ngModel)]="this.kymw0900Model.bundlePrice" (change)="eventBundlePrice_FOCUS_OUTHandler(null)" [style.width.rem]="4">
                  </div>
                  <label class="list-input-title">確定入数</label>
                  <div class="list-input-content">
                    <input type="text" #txti_FixContainNum id="txti_FixContainNum" class="text-label-required"
                      [tabindex]="0" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="4"
                      [(ngModel)]="this.kymw0900Model.fixContainNum" [style.width.rem]="4">
                  </div>
                  <label class="list-input-title">組数</label>
                  <div class="list-input-content">
                    <input type="text" #txti_SetQuantity id="txti_SetQuantity" class="text-label-required"
                      [tabindex]="0" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="1"
                      [(ngModel)]="this.kymw0900Model.setQuantity" (keydown)="nextFocus($event)" [style.width.rem]="4">
                  </div>
                </div>
              </wj-tab>
              <wj-tab forcedEnabledMode="true" tabindex="0" id="cnv_Spec1InfoTab">
                <a id="a_Spec1Info" #a_Spec1Info (keydown)="nextFocusForReadonlyUser($event)">仕様書１</a>
                <div class="element-column">
                  <div class="column-list">
                    <label class="list-input-title" style="width: 174px;">訂正元eBASE NO</label>
                    <div class="list-input-content">
                      <input #txti_EbaseSpecCode type="text" class="e-base-no" id="txti_EbaseSpecCode"
                        plessInputTextSub [restrict]="'[ -￮]'" readonly
                        [(ngModel)]="this.kymw0900Model.ebaseSpecCode" />
                    </div>
                    <label class="list-input-title" style="width: 174px;">仕様書適用日</label>
                    <div class="list-input-content">
                      <input #txti_SpecApplyDate type="text" id="txti_SpecApplyDate"
                        plessInputTextSub [restrict]="'[ -￮]'" readonly
                        [(ngModel)]="this.kymw0900Model.specApplyDate" [style.width.rem]="15" />
                    </div>
                  </div>
                  <div class="block-row">
                    <div class="column-list">
                      <div class="list-input-title layout_balance" style="width: 174px;">
                        <label>メーカー名称</label>
                        <label aria-label="誌面＋EC：メーカー名称表示 &#10003;時のみ" data-microtip-position="top" role="tooltip" class="question">
                          <fa-icon [icon]="iconQuestion"></fa-icon></label>
                      </div>
                      <div class="list-input-content">
                        <app-text-input #txti_MakerName id="txti_MakerName" [subid]="'txti_MakerName'" [fullOnly]="true"
                          [restrict]="'[ -￮]'" [maxChars]="20" [forcedEnabledMode]="'none'" [tabindex]="0"
                          [displayCountField]="true" [(ngModel)]="this.kymw0900Model.makerName" [style.width.rem]="27">
                        </app-text-input>
                        <label>
                          <input #chk_MakerNamePublishType type="checkbox" id="chk_MakerNamePublishType"
                            forcedEnabledMode="none" [tabindex]="0"
                            [(ngModel)]="this.kymw0900Model.makerNamePublishType" />
                          <span>メーカー名称表示</span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="block-row">
                    <div class="column-list" style="width: 376px;">
                      <label class="list-input-title" style="width: 174px;">ﾋﾟｰｽｻｲｽﾞ(縦)</label>
                      <div class="list-input-content">
                        <input type="text" #txti_PeaceSizeLength id="txti_PeaceSizeLength" plessInputTextSub
                          [restrict]="'[0-9]'" [maxlength]="4" forcedEnabledMode="none" [tabindex]="0"
                          [(ngModel)]="this.kymw0900Model.peaceSizeLength" [style.width.rem]="5" />
                      </div>
                      <label class="list-input-title">ﾋﾟｰｽｻｲｽﾞ(横)</label>
                      <div class="list-input-content">
                        <input type="text" #txti_PeaceSizeWidth id="txti_PeaceSizeWidth" plessInputTextSub
                          [restrict]="'[0-9]'" [maxlength]="4" forcedEnabledMode="none" [tabindex]="0"
                          [(ngModel)]="this.kymw0900Model.peaceSizeWidth" [style.width.rem]="5" />
                      </div>
                      <label class="list-input-title">ﾋﾟｰｽｻｲｽﾞ(高)</label>
                      <div class="list-input-content">
                        <input type="text" #txti_PeaceSizeHight id="txti_PeaceSizeHight" plessInputTextSub
                          [restrict]="'[0-9]'" [maxlength]="4" forcedEnabledMode="none" [tabindex]="0"
                          [(ngModel)]="this.kymw0900Model.peaceSizeHight" [style.width.rem]="5" />
                      </div>
                      <label class="list-input-title">ﾋﾟｰｽ重量</label>
                      <div class="list-input-content">
                        <input #txti_PeaceWeight type="text" id="txti_PeaceWeight" plessInputTextSub
                          [restrict]="'[0-9]'" [maxlength]="5" forcedEnabledMode="none" [tabindex]="0"
                          [(ngModel)]="this.kymw0900Model.peaceWeight" [style.width.rem]="5" />
                      </div>
                    </div>
                    <div class="column-list">
                      <label class="list-input-title" style="width: 174px;">ｹｰｽｻｲｽﾞ(縦)</label>
                      <div class="list-input-content">
                        <input type="text" #txti_CaseSizeLength id="txti_CaseSizeLength" plessInputTextSub
                          [restrict]="'[0-9]'" [maxlength]="4" forcedEnabledMode="none" [tabindex]="0"
                          [(ngModel)]="this.kymw0900Model.caseSizeLength" [style.width.rem]="5" />
                      </div>
                      <label class="list-input-title">ｹｰｽｻｲｽﾞ(横)</label>
                      <div class="list-input-content">
                        <input type="text" #txti_CaseSizeWidth id="txti_CaseSizeWidth" plessInputTextSub
                          [restrict]="'[0-9]'" [maxlength]="4" forcedEnabledMode="none" [tabindex]="0"
                          [(ngModel)]="this.kymw0900Model.caseSizeWidth" [style.width.rem]="5" />
                      </div>
                      <label class="list-input-title">ｹｰｽｻｲｽﾞ(高)</label>
                      <div class="list-input-content">
                        <input type="text" #txti_CaseSizeHight id="txti_CaseSizeHight" plessInputTextSub
                          [restrict]="'[0-9]'" [maxlength]="4" forcedEnabledMode="none" [tabindex]="0"
                          [(ngModel)]="this.kymw0900Model.caseSizeHight" [style.width.rem]="5" />
                      </div>
                      <label class="list-input-title">ｹｰｽ重量</label>
                      <div class="list-input-content">
                        <input type="text" #txti_CaseWeight id="txti_CaseWeight" plessInputTextSub [restrict]="'[0-9]'"
                          [maxlength]="5" forcedEnabledMode="none" [tabindex]="0"
                          [(ngModel)]="this.kymw0900Model.caseWeight" [style.width.rem]="5" />
                      </div>
                    </div>
                  </div>
                  <div class="column-list">
                    <div class="list-input-title layout_balance">
                      <label>原産国加工地</label>
                      <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                        <fa-icon [icon]="iconQuestion"></fa-icon></label>
                    </div>
                    <div class="list-input-content">
                      <app-text-area #txta_StringValue1 [width]="560" [height]="80" [fullOnly]="true"
                        [restrict]="'[ -￮]'" [maxChars]="200" id="txta_StringValue1" [subid]="'txta_StringValue1'"
                        [forcedEnabledMode]="'none'" [tabindex]="0" [displayCountField]="true" [fullOnly]="true"
                        [(ngModel)]="this.kymw0900Model.stringValue1">
                      </app-text-area>
                    </div>
                    <div class="list-input-title layout_balance" style="width: 174px;">
                      <label type="text" [style.white-space]="'nowrap'">原材料情報</label>
                      <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                        <fa-icon [icon]="iconQuestion"></fa-icon></label>
                    </div>
                    <div class="list-input-content">
                      <app-text-area #txta_StringValue2 [width]="560" [height]="85" [restrict]="'[ -￮]'"
                        [maxChars]="2000" id="txta_StringValue2" [subid]="'txta_StringValue2'"
                        [forcedEnabledMode]="'none'" [fullOnly]="true" [tabindex]="0"
                        [(ngModel)]="this.kymw0900Model.stringValue2">
                      </app-text-area>
                    </div>
                    <div class="list-input-title layout_balance">
                      <label type="text" [style.white-space]="'nowrap'">コンタミ情報</label>
                      <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                        <fa-icon [icon]="iconQuestion"></fa-icon></label>
                    </div>
                    <div class="list-input-content">
                      <app-text-area #txta_StringValue3 [width]="560" [height]="80" [restrict]="'[ -￮]'"
                        [maxChars]="200" id="txta_StringValue3" [subid]="'txta_StringValue3'"
                        [forcedEnabledMode]="'none'" [fullOnly]="true" [tabindex]="0" [displayCountField]="true"
                        [(ngModel)]="this.kymw0900Model.stringValue3" [allowMultiLine]="false">
                      </app-text-area>
                    </div>
                    <div class="list-input-title layout_balance">
                      <label type="text" [style.white-space]="'nowrap'">添加物情報</label>
                      <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                        <fa-icon [icon]="iconQuestion"></fa-icon></label>
                    </div>
                    <div class="list-input-content">
                      <app-text-area #txta_StringValue5 [width]="560" [height]="80" [restrict]="'[ -￮]'"
                        [maxChars]="200" id="txta_StringValue5" [subid]="'txta_StringValue5'"
                        [forcedEnabledMode]="'none'" [fullOnly]="true" [tabindex]="0" [displayCountField]="true"
                        [(ngModel)]="this.kymw0900Model.stringValue5" [allowMultiLine]="false">
                      </app-text-area>
                    </div>
                    <div class="list-input-title">
                      <label>遺伝子組換表示区分</label>
                    </div>
                    <div class="list-input-content">
                      <app-code-combo-box #cmb_GeneRecombinationDivList [blank]="false" [codeDiv]="'ct361'"
                        id="cmb_GeneRecombinationDivList" [subid]="'cmb_GeneRecombinationDivList'"
                        [labelField]="'codeValueName'" [tabindex]="0" [style.width.rem]="5">
                      </app-code-combo-box>
                    </div>
                    <div class="list-input-title layout_balance">
                      <label type="text" [style.white-space]="'nowrap'">遺伝子組換</label>
                      <label aria-label='誌面＋EC：遺伝子組換表示区分="1"の場合' data-microtip-position="top" role="tooltip" class="question">
                        <fa-icon [icon]="iconQuestion"></fa-icon></label>
                    </div>
                    <div class="list-input-content">
                      <app-text-area #txta_StringValue6 [width]="560" [height]="80" [restrict]="'[ -￮]'"
                        [maxChars]="200" id="txta_StringValue6" [subid]="'txta_StringValue6'"
                        [forcedEnabledMode]="'none'" [tabindex]="0" [displayCountField]="true" [fullOnly]="true"
                        [(ngModel)]="this.kymw0900Model.stringValue6" (keydown)="nextFocus($event)"
                        [allowMultiLine]="false">
                      </app-text-area>
                    </div>
                    <!-- カロリー情報は非表示へ -->
                    <label class="list-input-title" [style.display]="'none'">カロリー情報</label>
                    <div class="list-input-content">
                      <app-text-area #txta_StringValue4 [restrict]="'[ -￮]'" [maxChars]="200" id="txta_StringValue4"
                        [forcedEnabledMode]="'none'" [tabindex]="0" [style.display]="'none'"
                        [displayCountField]="true" [fullOnly]="true" [(ngModel)]="this.kymw0900Model.stringValue4">
                      </app-text-area>
                    </div>
                  </div>
                </div>
              </wj-tab>
              <wj-tab forcedEnabledMode="true" [tabindex]="0" id="cnv_Spec2InfoTab">
                <a id="a_Spec2Info" #a_Spec2Info>仕様書２</a>
                <div class="column-list">
                  <label class="list-input-title" style="width: 153px;">アレルゲン調査対象</label>
                  <div class="list-input-content">
                    <app-code-combo-box #cmb_AllergenTergetType class="combo-box-normal" id="cmb_AllergenTergetType"
                      [subid]="'cmb_AllergenTergetType'" [codeDiv]="'ct313'" [blank]="false"
                      [labelField]="'codeValueName'" [tabindex]="0" [(ngModel)]="this.kymw0900Model.allergenTergetType">
                    </app-code-combo-box>
                  </div>
                  <div class="list-input-title layout_balance">
                    <label>アレルゲン情報</label>
                    <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                      <fa-icon [icon]="iconQuestion"></fa-icon></label>
                  </div>
                  <div class="list-input-content">
                    <wj-flex-grid #dtg_AllergenInfo [style.height.px]="545" id="dtg_AllergenInfo"
                      [tabindex]="0" [itemsSource]="this.kymw0900Model.allergenInfo" [headersVisibility]="'Column'"
                      [allowSorting]="false" sortableColumns="false" horizontalGridLines="true" [allowDragging]="'None'"
                      [allowResizing]="'Columns'" [selectionMode]="'Row'" [isReadOnly]="true"
                      (keydown)="nextFocus($event)" [style.width.px]="700">
                      <wj-flex-grid-column [minWidth]="5" [width]="50" [binding]="'SelectValue'" [header]="'表示'"
                        [align]="'center'" [isReadOnly]="true">
                        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                          <input type="checkbox" id="SelectValue" [(ngModel)]="cell.item.SelectValue"
                            [disabled]="this.kymw0900Model.allergenFlag || this.kymw0900Model.isDisabledForGrid ? true : false"
                            (change)="editAllergenTargetType(cell.item.SelectValue, cell.item.PublishDiv);eventEditHandler();"
                            (keydown)="nextFocus($event)" id="cb_algen_{{cell.row.index}}"
                            (mouseup)="$event.stopPropagation()" />
                        </ng-template>
                      </wj-flex-grid-column>
                      <wj-flex-grid-column [minWidth]="5" [width]="60" [binding]="'ComponentValue'" [header]="'含有'"
                        [align]="'center'">
                      </wj-flex-grid-column>
                      <wj-flex-grid-column [minWidth]="5" [width]="571" [binding]="'AllergenName'" [header]="'アレルゲン'"
                        [align]="'left'" [isContentHtml]="true">
                        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                          <div [align]="'left'" [class.allergen-color]="cell.item.PublishDiv=='1'">
                            {{cell.item.AllergenName}}
                          </div>
                        </ng-template>
                      </wj-flex-grid-column>
                    </wj-flex-grid>
                  </div>
                </div>
              </wj-tab>
              <wj-tab forcedEnabledMode="true" [tabindex]="0" id="cnv_PromotionInfoTab">
                <a id="a_PromotionInfo" #a_PromotionInfo>プロモ</a>
                <div>
                  <h2>企画マスタ管理マーク</h2>
                  <div class="column-list">
                    <label class="list-input-title" style="width: 90px;">グループ</label>
                    <div class="list-input-content">
                      <select #cmb_MarkGroup id="cmb_MarkGroup" tabindex="0" [(ngModel)]="this.kymw0900Model.markGroup"
                        (change)="eventMarkGroup_CHANGEHandler(null)">
                        <ng-template ngFor let-item [ngForOf]="this.kymw0900Model.markGroupList">
                          <option value="{{item.MarkGroup}}">{{item.MarkGroupName}}</option>
                        </ng-template>
                      </select>
                      <app-checkbox-label #chk_AllcoopValue2 [label]="'すべての生協に同一の設定'" id="chk_AllcoopValue2"
                        [subid]="'chk_AllcoopValue2'" [tabindex]="0" [(ngModel)]="this.kymw0900Model.allcoopValue2">
                      </app-checkbox-label>
                    </div>
                  </div>
                  <wj-flex-grid #dtg_MarkInfo [style.height.px]="515" id="dtg_MarkInfo"
                    [tabindex]="0" [selectionMode]="'Row'" [itemsSource]="this.kymw0900Model.markInfoList"
                    [headersVisibility]="'Column'" [allowSorting]="true" horizontalScrollPolicy="auto" editable="true"
                    rowHeight="20" [allowDragging]="'None'" [selectionMode]="'Row'" [allowResizing]="'Columns'"
                    [isReadOnly]="true" (keydown)="nextFocus($event)">
                    <wj-flex-grid-column [minWidth]="5" [width]="60" [binding]="'MarkCode'" [header]="'コード'">
                    </wj-flex-grid-column>
                    <wj-flex-grid-column [minWidth]="5" [width]="380" [binding]="'MarkName'" [header]="'マーク内容'">
                    </wj-flex-grid-column>
                    <wj-flex-grid-column [minWidth]="5" [width]="50" [binding]="'SelectValue1'" [header]="'い'"
                      [allowSorting]="false" [isReadOnly]="true" [align]="'center'">
                      <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                        <input type="checkbox" [(ngModel)]="cell.item.SelectValue1"
                          (click)="checkBoxEventMarkInfo($event,dtg_MarkInfo);eventEditHandler();" 
                          [disabled]="this.kymw0900Model.isDisabledForGrid ||
                          this.kymw0900Model.iconListDisable[kymw00Model.COOP_CODE_IB]" [tabindex]="-1"
                          id="cb_mark_info_1_{{cell.row.index}}" (mouseup)="$event.stopPropagation()"
                          (change)="promotionInfoUpdateIconCheck($event, cell, kymw00Model.COOP_CODE_IB)" />
                      </ng-template>
                    </wj-flex-grid-column>
                    <wj-flex-grid-column [minWidth]="5" [width]="50" [binding]="'SelectValue2'" [header]="'と'"
                      [allowSorting]="false" [isReadOnly]="true" [align]="'center'">
                      <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                        <input type="checkbox" [(ngModel)]="cell.item.SelectValue2"
                          (click)="checkBoxEventMarkInfo($event,dtg_MarkInfo);eventEditHandler();" 
                          [disabled]="this.kymw0900Model.isDisabledForGrid ||
                          this.kymw0900Model.iconListDisable[kymw00Model.COOP_CODE_TO]" [tabindex]="-1"
                          id="cb_mark_info_2_{{cell.row.index}}" (mouseup)="$event.stopPropagation()"
                          (change)="promotionInfoUpdateIconCheck($event, cell, kymw00Model.COOP_CODE_TO)" />
                      </ng-template>
                    </wj-flex-grid-column>
                    <wj-flex-grid-column [minWidth]="5" [width]="50" [binding]="'SelectValue3'" [header]="'ぐ'"
                      [allowSorting]="false" [isReadOnly]="true" [align]="'center'">
                      <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                        <input type="checkbox" [(ngModel)]="cell.item.SelectValue3"
                          (click)="checkBoxEventMarkInfo($event,dtg_MarkInfo);eventEditHandler();" 
                          [disabled]="this.kymw0900Model.isDisabledForGrid ||
                          this.kymw0900Model.iconListDisable[kymw00Model.COOP_CODE_GU]" [tabindex]="-1"
                          id="cb_mark_info_3_{{cell.row.index}}" (mouseup)="$event.stopPropagation()"
                          (change)="promotionInfoUpdateIconCheck($event, cell, kymw00Model.COOP_CODE_GU)" />
                      </ng-template>
                    </wj-flex-grid-column>
                    <wj-flex-grid-column [minWidth]="5" [width]="50" [binding]="'SelectValue4'" [header]="'ち'"
                      [allowSorting]="false" [isReadOnly]="true" [align]="'center'">
                      <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                        <input type="checkbox" [(ngModel)]="cell.item.SelectValue4"
                          (click)="checkBoxEventMarkInfo($event,dtg_MarkInfo);eventEditHandler();"
                          [disabled]="this.kymw0900Model.isDisabledForGrid ||
                          this.kymw0900Model.iconListDisable[kymw00Model.COOP_CODE_TI]" [tabindex]="-1"
                          id="cb_mark_info_4_{{cell.row.index}}" (mouseup)="$event.stopPropagation()"
                          (change)="promotionInfoUpdateIconCheck($event, cell, kymw00Model.COOP_CODE_TI)" />
                      </ng-template>
                    </wj-flex-grid-column>
                    <wj-flex-grid-column [minWidth]="5" [width]="50" [binding]="'SelectValue5'" [header]="'さ'"
                      [allowSorting]="false" [isReadOnly]="true" [align]="'center'">
                      <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                        <input type="checkbox" [(ngModel)]="cell.item.SelectValue5"
                          (click)="checkBoxEventMarkInfo($event,dtg_MarkInfo);eventEditHandler();" 
                          [disabled]="this.kymw0900Model.isDisabledForGrid ||
                          this.kymw0900Model.iconListDisable[kymw00Model.COOP_CODE_SA]" [tabindex]="-1"
                          id="cb_mark_info_5_{{cell.row.index}}" (mouseup)="$event.stopPropagation()"
                          (change)="promotionInfoUpdateIconCheck($event, cell, kymw00Model.COOP_CODE_SA)" />
                      </ng-template>
                    </wj-flex-grid-column>
                    <wj-flex-grid-column [minWidth]="5" [width]="50" [binding]="'SelectValue6'" [header]="'とう'"
                      [allowSorting]="false" [isReadOnly]="true" [align]="'center'">
                      <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                        <input type="checkbox" [(ngModel)]="cell.item.SelectValue6"
                          (click)="checkBoxEventMarkInfo($event,dtg_MarkInfo);eventEditHandler();" 
                          [disabled]="this.kymw0900Model.isDisabledForGrid ||
                          this.kymw0900Model.iconListDisable[kymw00Model.COOP_CODE_TK]" [tabindex]="-1"
                          id="cb_mark_info_6_{{cell.row.index}}" (mouseup)="$event.stopPropagation()"
                          (change)="promotionInfoUpdateIconCheck($event, cell, kymw00Model.COOP_CODE_TK)" />
                      </ng-template>
                    </wj-flex-grid-column>
                    <wj-flex-grid-column [minWidth]="5" [width]="50" [binding]="'SelectValue7'" [header]="'な'"
                      [allowSorting]="false" [isReadOnly]="true" [align]="'center'">
                      <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                        <input type="checkbox" [(ngModel)]="cell.item.SelectValue7"
                          (click)="checkBoxEventMarkInfo($event,dtg_MarkInfo);eventEditHandler();" 
                          [disabled]="this.kymw0900Model.isDisabledForGrid ||
                          this.kymw0900Model.iconListDisable[kymw00Model.COOP_CODE_NA]" [tabindex]="-1"
                          id="cb_mark_info_7_{{cell.row.index}}" (mouseup)="$event.stopPropagation()"
                          (change)="promotionInfoUpdateIconCheck($event, cell, kymw00Model.COOP_CODE_NA)" />
                      </ng-template>
                    </wj-flex-grid-column>
                    <wj-flex-grid-column [minWidth]="5" [width]="50" [binding]="'SelectValue8'" [header]="'に'"
                      [allowSorting]="false" [isReadOnly]="true" [align]="'center'">
                      <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                        <input type="checkbox" [(ngModel)]="cell.item.SelectValue8"
                          (click)="checkBoxEventMarkInfo($event,dtg_MarkInfo);eventEditHandler();"
                          [disabled]="this.kymw0900Model.isDisabledForGrid ||
                          this.kymw0900Model.iconListDisable[kymw00Model.COOP_CODE_NI]" [tabindex]="-1"
                          id="cb_mark_info_8_{{cell.row.index}}" (mouseup)="$event.stopPropagation()"
                          (change)="promotionInfoUpdateIconCheck($event, cell, kymw00Model.COOP_CODE_NI)" />
                      </ng-template>
                    </wj-flex-grid-column>
                  </wj-flex-grid>
                </div>
              </wj-tab>
              <wj-tab #cnv_NutrientTab id="cnv_NutrientTab" tabindex="0" forcedEnabledMode="true">
                <a id="a_Nutrient" #a_Nutrient>栄養成分</a>
                <div class="column-list"  style="grid-template-columns: 100px 753px;">
                  <div class="list-input-title layout_balance">
                    <label>分析単位</label>
                    <label aria-label="誌面＋EC" data-microtip-position="bottom" role="tooltip" class="question">
                      <fa-icon [icon]="iconQuestion"></fa-icon></label>
                  </div>
                  <div class="list-input-content">
                    <wj-flex-grid #dtg_NutrientUnitList id="dtg_NutrientUnitList" [style.height.px]="52"
                      [style.width.%]="100" [allowDragging]="'None'" [allowSorting]="false" [tabindex]="0"
                      [headersVisibility]="'None'" [itemsSource]="this.kymw0900Model.nutrientUnitList"
                      [selectionMode]="'Row'" [isReadOnly]="true">
                      <wj-flex-grid-column [minWidth]="5" [width]="'*'" [binding]="'AnalysisUnit'" [wordWrap]="true">
                      </wj-flex-grid-column>
                    </wj-flex-grid>
                  </div>
                  <div class="list-input-title layout_balance">
                    <label>栄養成分</label>
                    <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                      <fa-icon [icon]="iconQuestion"></fa-icon></label>
                  </div>
                  <div class="list-input-content">
                    <wj-flex-grid #dtg_NutrientComponentList [style.height.px]="364" [style.width.px]="753"
                      [allowDragging]="'None'" [allowSorting]="false" id="dtg_NutrientComponentList" [tabindex]="0"
                      [itemsSource]="this.kymw0900Model.nutrientDetailList" [allowMerging]="'ColumnHeaders'"
                      [isReadOnly]="true" sortableColumns="false" rowHeight="25" horizontalGridLines="true"
                      [selectionMode]="'Row'" [headersVisibility]="'Column'" [allowResizing]="'Columns'"
                      (keydown)="nextFocusForReadonlyUser($event)">
                      <wj-flex-grid-column [minWidth]="5" [width]="510" [binding]="'NutritionalName'" [header]="'栄養成分名'"
                        [isContentHtml]="true">
                        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                          <div [class.nutritional-color]="cell.item.PublishDiv=='1'">
                            {{cell.item.NutritionalName}}
                          </div>
                        </ng-template>
                      </wj-flex-grid-column>
                      <wj-flex-grid-column [minWidth]="5" [width]="120" [binding]="'NutritionalQuantity'"
                        [header]="'栄養成分値'" [align]="'right'">
                      </wj-flex-grid-column>
                      <wj-flex-grid-column [minWidth]="5" [width]="104" [binding]="'NutritionalUnit'" [header]="'単位'">
                      </wj-flex-grid-column>
                    </wj-flex-grid>
                  </div>
                  <div class="list-input-title title-tooltip-column">
                    <label forcedEnabledMode="true">栄養成分備考</label>
                    <div class="layout_end">
                      <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                      <fa-icon [icon]="iconQuestion"></fa-icon></label>
                    </div>
                  </div>
                  <div class="list-input-content">
                    <app-text-area #txta_NutrientComponentComment id="txta_NutrientComponentComment"
                      [subid]="'txta_NutrientComponentComment'" plessInputTextSub
                      [(ngModel)]="this.kymw0900Model.nutrientNote" [restrict]="'[ -￮]'" [displayCountField]="true"
                      [maxChars]="200" [width]="'*'" [height]="115" [disabled]="true" [horizontalScrollPolicy]="'off'"
                      [tabindex]="-1">
                    </app-text-area>
                  </div>
                  <label class="list-input-title">複数栄養成分</label>
                  <div class="list-input-content">
                    <app-checkbox-label #chk_HasMultiNutrientInfo id="chk_HasMultiNutrientInfo"
                      [subid]="'chk_HasMultiNutrientInfo'" [forcedEnabledMode]="'true'" [tabindex]="0" label="複数あり"
                      [(ngModel)]="this.kymw0900Model.hasMultiNutrientInfo"
                      (clickOutput)="eventHasMultiNutrientInfo_CLICKHandler(null)" (keydown)="nextFocus($event)">
                    </app-checkbox-label>
                  </div>
                </div>
              </wj-tab>
              <wj-tab #cnv_MultiNutrientTab id="cnv_MultiNutrientTab"
                [isDisabled]="!this.kymw0900Model.hasMultiNutrientInfo" tabindex="0" forcedEnabledMode="true">
                <a id="a_MultiNutrient" #a_MultiNutrient>複数栄養成分</a>
                <div class="column-list" style="grid-template-columns: 100px 753px;">
                  <div class="list-input-title layout_balance">
                    <label>分析単位</label>
                    <label aria-label="誌面＋EC" data-microtip-position="bottom" role="tooltip" class="question">
                      <fa-icon [icon]="iconQuestion"></fa-icon></label>
                  </div>
                  <div class="list-input-content">
                    <wj-flex-grid #dtg_NutrientUnitListMulti id="dtg_NutrientUnitListMulti" [style.height.px]="130"
                      [style.width.%]="100" [allowDragging]="'None'" [allowSorting]="false" [tabindex]="0"
                      rowHeight="25" selectionColor="0xFFFFFF" [itemsSource]="this.kymw0900Model.nutrientUnitListMulti"
                      [headersVisibility]="'None'" [selectionMode]="'Row'" [isReadOnly]="true" forcedEnabledMode="true"
                      (selectionChanged)="eventNutrientUnitListMulti_CHANGEHandler(dtg_NutrientUnitListMulti)">
                      <wj-flex-grid-column [minWidth]="5" [width]="'*'" [binding]="'AnalysisUnit'" [wordWrap]="true">
                      </wj-flex-grid-column>
                    </wj-flex-grid>
                  </div>
                  <div class="list-input-title layout_balance">
                    <label>栄養成分</label>
                    <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                      <fa-icon [icon]="iconQuestion"></fa-icon></label>
                  </div>
                  <div class="list-input-content">
                    <wj-flex-grid #dtg_NutrientComponentListMulti [allowDragging]="'None'" [allowSorting]="false"
                      [style.height.px]="320" [style.width.px]="753" id="dtg_NutrientComponentListMulti" [tabindex]="0"
                      [itemsSource]="this.kymw0900Model.nutrientDetailListMulti" [allowMerging]="'ColumnHeaders'"
                      [headersVisibility]="'Column'" [selectionMode]="'Row'" [isReadOnly]="true"
                      [allowResizing]="'Columns'" (keydown)="nextFocus($event);nextFocusForReadonlyUser($event);">
                      <wj-flex-grid-column [minWidth]="5" [width]="514" [binding]="'NutritionalName'"
                        [header]="'栄養成分名'">
                        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                          <div [class.nutritional-color]="cell.item.PublishDiv=='1'">
                            {{cell.item.NutritionalName}}
                          </div>
                        </ng-template>
                      </wj-flex-grid-column>
                      <wj-flex-grid-column [minWidth]="5" [width]="120" [binding]="'NutritionalQuantity'"
                        [header]="'栄養成分値'" [align]="'right'">
                      </wj-flex-grid-column>
                      <wj-flex-grid-column [minWidth]="5" [width]="100" [binding]="'NutritionalUnit'" [header]="'単位'">
                      </wj-flex-grid-column>
                    </wj-flex-grid>
                  </div>
                  <div  class="list-input-title title-tooltip-column">
                    <label>栄養成分備考</label>
                    <div class="layout_end">
                      <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                        <fa-icon [icon]="iconQuestion"></fa-icon></label>
                    </div>
                  </div>
                  <div class="list-input-content">
                    <app-text-area #txta_NutrientComponentCommentMulti id="txta_NutrientComponentCommentMulti"
                      [subid]="'txta_NutrientComponentCommentMulti'" [disabled]="true" [maxChars]="200" [width]="'*'"
                      [height]="115" (keydown)="nextFocus($event)" [(ngModel)]="this.kymw0900Model.nutrientNoteMulti"
                      [horizontalScrollPolicy]="'off'" [tabindex]="-1">
                    </app-text-area>
                  </div>
                </div>
              </wj-tab>
              <wj-tab #cnv_EnvInfoTab forcedEnabledMode="true" tabIndex="0" id="cnv_EnvInfoTab">
                <a id="a_EnvInfo" #a_EnvInfo>環境関連</a>
                <div class="column-list">
                  <label class="list-input-title">環境区分</label>
                  <div class="list-input-content" style="align-items: start;">
                    <div class="element-column">
                      <div class="block-row">
                        <app-radio-label #rdb_Ecology0 value="0" label="なし" id="rdb_Ecology0" [subid]="'rdb_Ecology0'"
                          name="rdbg_EcologyDiv" [forcedEnabledMode]="'none'" [tabindex]="0"
                          [(ngModel)]="this.kymw0900Model.ecologyDiv" (change)="eventCologyDiv_CHANGEHandler()">
                        </app-radio-label>
                        <app-radio-label #rdb_Ecology1 value="1" label="あり" id="rdb_Ecology1" [subid]="'rdb_Ecology1'"
                          name="rdbg_EcologyDiv" [forcedEnabledMode]="'none'" [tabindex]="0" #rdbg_EcologyDiv
                          [(ngModel)]="this.kymw0900Model.ecologyDiv" (change)="eventCologyDiv_CHANGEHandler()">
                        </app-radio-label>
                      </div>
                      <!-- データグリッド領域(環境区分) -->
                      <wj-flex-grid #dtg_GoodsEcologyList class="list-input-content" id="dtg_GoodsEcologyList"
                        [allowDragging]="'None'" [tabindex]="0" [allowSorting]="false" rowHeight="25"
                        [style.height.px]="210" [style.width.px]="770" [itemsSource]="this.kymw0900Model.goodsEcology"
                        [headersVisibility]="'Column'" [selectionMode]="'Row'" [isReadOnly]="true"
                        [allowResizing]="'Columns'">
                        <wj-flex-grid-column [minWidth]="5" [width]="50" [binding]="'SelectValue'" [header]="'選択'"
                          [align]="'center'">
                          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                            <input type="checkbox" id="SelectValue" [(ngModel)]="cell.item.SelectValue"
                              [disabled]="!this.kymw0900Model.goodsEcologyFlag || this.kymw0900Model.isDisabledForGrid ? true : false"
                              [tabindex]="-1" id="cb_goods_eco_{{cell.row.index}}"
                              (mouseup)="$event.stopPropagation()" />
                          </ng-template>
                        </wj-flex-grid-column>
                        <wj-flex-grid-column [minWidth]="5" [width]="701" [binding]="'EcologyGoodsName'"
                          [header]="'環境配慮商品'">
                        </wj-flex-grid-column>
                      </wj-flex-grid>
                    </div>
                  </div>
                  <!-- データグリッド領域(温暖化防止) -->
                  <label class="list-input-title">温暖化防止</label>
                  <div class="list-input-content">
                    <wj-flex-grid #dtg_GoodsGWStopList id="dtg_GoodsGWStopList" [style.height.px]="86"
                      [style.width.px]="770" [allowDragging]="'None'" [allowSorting]="false" [tabindex]="0"
                      rowHeight="25" [itemsSource]="this.kymw0900Model.goodsGWStop" [headersVisibility]="'Column'"
                      [selectionMode]="'Row'" [isReadOnly]="true" [allowResizing]="'Columns'">
                      <wj-flex-grid-column [minWidth]="5" [width]="50" [binding]="'SelectValue'" [header]="'選択'"
                        [align]="'center'" [isReadOnly]="true">
                        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                          <input type="checkbox" id="SelectValue" [tabindex]="-1" [(ngModel)]="cell.item.SelectValue"
                            [disabled]="this.kymw0900Model.isDisabledForGrid ? true : false"
                            (change)="eventEditHandler()" [tabindex]="-1" id="cb_good_gws_{{cell.row.index}}"
                            (mouseup)="$event.stopPropagation()" />
                        </ng-template>
                      </wj-flex-grid-column>
                      <wj-flex-grid-column [minWidth]="5" [width]="703" [binding]="'GoodsGWStopName'"
                        [header]="'温暖化防止'">
                      </wj-flex-grid-column>
                    </wj-flex-grid>
                  </div>
                  <label class="list-input-title">容器包装材</label>
                  <div class="list-input-content">
                    <!-- データグリッド領域(容器包装材) -->
                    <wj-flex-grid #dtg_ContainPackingList [style.height.px]="240" [style.width.px]="770"
                      id="dtg_ContainPackingList" [allowDragging]="'None'" [tabindex]="0" [allowSorting]="false"
                      rowHeight="25" [itemsSource]="this.kymw0900Model.containPackingList"
                      [headersVisibility]="'Column'" [selectionMode]="'Row'" [isReadOnly]="true"
                      [allowResizing]="'Columns'">
                      <wj-flex-grid-column [minWidth]="5" [width]="50" [binding]="'SelectValue'" [header]="'選択'"
                        [align]="'center'" [isReadOnly]="true">
                        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                          <input type="checkbox" id="SelectValue" [tabindex]="-1" [(ngModel)]="cell.item.SelectValue"
                            (change)="kymw0900Model.updateContainPacking(cell.item);eventEditHandler();"
                            [disabled]="this.kymw0900Model.isDisabledForGrid ? true : false" [tabindex]="-1"
                            id="cb_contain_pack_{{cell.row.index}}" (mouseup)="$event.stopPropagation()" />
                        </ng-template>
                      </wj-flex-grid-column>
                      <wj-flex-grid-column [minWidth]="5" [width]="60" [binding]="'ContainDiv'" [header]="'区分'">
                      </wj-flex-grid-column>
                      <wj-flex-grid-column [minWidth]="5" [width]="243" [binding]="'ContainDivName'" [header]="'区分名'">
                      </wj-flex-grid-column>
                      <wj-flex-grid-column [minWidth]="5" [width]="73" [binding]="'ContainKind'" [header]="'素材'">
                      </wj-flex-grid-column>
                      <wj-flex-grid-column [minWidth]="5" [width]="235" [binding]="'ContainKindName'" [header]="'素材名'">
                      </wj-flex-grid-column>
                      <wj-flex-grid-column [minWidth]="5" [width]="90" [binding]="'PackMaterialWeight'" [header]="'重量'"
                        [align]="'right'">
                        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                          <input type="text" class="text-right" plessInputTextSub [restrict]="'[.0-9]'" [maxlength]="7"
                            [(ngModel)]="cell.item.PackMaterialWeight" autocomplete="off"
                            [disabled]="!this.kymw0900Model.containPackingList[cell.row.index].SelectValue || this.kymw0900Model.isDisabledForGrid ? true : false"
                            (change)="eventEditHandler();"
                            (keydown)="eventGridKeyDownHandler($event,dtg_ContainPackingList,5)" [tabindex]="0"
                            (focus)="this.dtg_ContainPackingList.select(cell.row.index, 5);" />
                        </ng-template>
                      </wj-flex-grid-column>
                    </wj-flex-grid>
                  </div>
                </div>
              </wj-tab>
            </wj-tab-panel>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Image" forcedEnabledMode="true" class="btn-secondary" [tabindex]="0"
            (click)="eventImage_CLICKHandler()">画像</button>
          <button id="btn_Image" forcedEnabledMode="true" class="btn-secondary" [tabindex]="0"
            (click)="eventHistory_CLICKHandler()">実績履歴</button>
          <button #btn_ChangeConfirmation class="btn-primary" id="btn_ChangeConfirmation" [tabindex]="0"
            (click)="eventChangeConfirmation_CLICKHandler(null)">アイテム情報の変更を確認</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="eventClose_CLICKHandler(null)"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>